export const SPECS = [
    {
        product: "matrice-400",
        specs: [
            {
                "title": "Aeronave",
                "specs": [
                    {
                        "key": "Peso de despegue (con hélices)",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003eSin baterías: 5020 ± 20 g\u003cbr\u003eCon baterías: 9740 ± 40 g\u003cbr\u003e\u003cbr\u003e\u003csup\u003eEl peso real del producto puede variar debido a diferencias en los materiales de los lotes y a factores externos. \u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Peso máx. de despegue",
                        "value": "15.8 kg",
                        "description": ""
                    },
                    {
                        "key": "Dimensiones",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003eDesplegado: 980 × 760 × 480 mm (la. × an. × al.) (con tren de aterrizaje)\u003cbr\u003ePlegado: 490 × 490 × 480 mm (la. × an. × al.) (con tren de aterrizaje y estabilizador)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eDimensiones máximas, sin contar las hélices.\u003c/sup\u003e\u003cbr\u003e\u003cbr\u003eDimensiones del estuche de la aeronave: 779 × 363 × 528 mm (la. × an. × al.)\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Carga útil máx.",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e6 kg\u003cbr\u003e\u003cbr\u003e  \u003csup\u003eLa capacidad de carga de instrumentos de 6 kg se mide en el tercer conector del estabilizador en condiciones a nivel del mar. La capacidad de carga de instrumentos disminuye a medida que aumenta la altitud. Para obtener detalles, consulta el manual de usuario oficial.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Tamaño de la hélice",
                        "value": "25 pulgadas",
                        "description": ""
                    },
                    {
                        "key": "Distancia diagonal entre ejes",
                        "value": "1070 mm",
                        "description": ""
                    },
                    {
                        "key": "Velocidad máx. de ascenso",
                        "value": "10 m/s",
                        "description": ""
                    },
                    {
                        "key": "Velocidad máx. de descenso",
                        "value": "8 m/s",
                        "description": ""
                    },
                    {
                        "key": "Velocidad horizontal máx. (al nivel del mar, sin viento)",
                        "value": "25 m/s",
                        "description": ""
                    },
                    {
                        "key": "Altitud máx. de despegue",
                        "value": "7000 m",
                        "description": ""
                    },
                    {
                        "key": "Tiempo máx. de vuelo (sin viento)",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e59 minutos\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido con la aeronave volando hacia adelante a una velocidad constante de 10 m/s en un entorno sin viento al nivel del mar, transportando solamente el H30T (peso total 10,670 g), y desde el 100 % del nivel de batería hasta el 0 %. Los datos son solo de referencia. La experiencia real puede variar en función del entorno, el uso y la versión del firmware.\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Tiempo máx. de vuelo estacionario (sin viento)",
                        "value": "\u003chtml\u003e\u003chtml\u003e53 minutos\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido con la aeronave en vuelo estacionario en un entorno sin viento al nivel del mar, transportando solamente el H30T (peso total 10,670 g), y desde el 100 % del nivel de batería hasta el 0 %. Los datos son solo de referencia. El tiempo de uso real puede variar en función del entorno, el uso y la versión del firmware.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Distancia máx. de vuelo (sin viento)",
                        "value": "\u003chtml\u003e\u003chtml\u003e49 km\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido con la aeronave volando hacia adelante a una velocidad constante de 17 m/s en un entorno sin viento a nivel del mar, desde el 100 % del nivel de batería hasta el 0 %. La experiencia real puede variar en función del entorno, el uso y la versión del firmware.\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Resistencia máx. al viento",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e12 m/s\u003cbr\u003e\u003cbr\u003e\u003csup\u003eResistencia máx. al viento durante el despegue y el aterrizaje. \u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Velocidad angular máx. de guiñada",
                        "value": "Guiñada: 100°/s",
                        "description": ""
                    },
                    {
                        "key": "Ángulo de inclinación máx.",
                        "value": "35°",
                        "description": ""
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "-20° a 50° C (sin radiación solar)",
                        "description": ""
                    },
                    {
                        "key": "Sistemas globales de navegación por satélite",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003eGPS + Galileo + BeiDou + GLONASS*\u003cbr\u003e\u003cbr\u003e\u003csup\u003e*GLONASS solo es compatible cuando el módulo RTK está activado. \u003c/sup\u003e\u003cbr\u003e\u003cbr\u003eGracias al receptor ADS-B por aire estándar y antenas duales, admite recepción hasta 20 km.\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Rango de precisión de vuelo estacionario (con viento moderado o sin viento)",
                        "value": "Vertical:\u003cbr\u003e±0.1 m (con posicionamiento visual)\u003cbr\u003e±0.5 m (con posicionamiento por satélite)\u003cbr\u003e±0.1 m (con posicionamiento RTK)\u003cbr\u003e\u003cbr\u003eHorizontal:\u003cbr\u003e±0.3 m (con posicionamiento visual)\u003cbr\u003e±0.5 m (con posicionamiento por satélite)\u003cbr\u003e±0.1 m (con posicionamiento RTK)",
                        "description": ""
                    },
                    {
                        "key": "Precisión de GNSS de RTK",
                        "value": "RTK fijo:\u003cbr\u003e1 cm + 1 ppm (horizontal); 1,5 cm + 1 ppm (vertical)",
                        "description": ""
                    },
                    {
                        "key": "Dirección RTK",
                        "value": "Admite dirección RTK con una precisión mejor que 2°",
                        "description": ""
                    },
                    {
                        "key": "Recepción de ADS-B por aire",
                        "value": "Gracias al receptor ADS-B por aire estándar y antenas duales, admite recepción hasta 20 km.",
                        "description": ""
                    },
                    {
                        "key": "Memoria interna",
                        "value": "N/D",
                        "description": ""
                    },
                    {
                        "key": "Puertos",
                        "value": "Puerto de depuración USB-C × 1: USB 2.0\u003cbr\u003eE-Port V2 × 4: En la parte inferior del dron, con la potencia de un solo puerto de 120 W\u003cbr\u003eInterfaz de adaptador celular 2 × 2: En la parte inferior del dron",
                        "description": ""
                    },
                    {
                        "key": "Modelo de hélice",
                        "value": "2510F",
                        "description": ""
                    },
                    {
                        "key": "Baliza",
                        "value": "Integrada en la aeronave",
                        "description": ""
                    },
                    {
                        "key": "Índice de protección de entrada",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003eIP55\u003cbr\u003e\u003cbr\u003e\u003csup\u003eEl índice de protección IP no es efectivo permanentemente y puede disminuir debido al desgaste del producto. \u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Modelo de motor",
                        "value": "7510",
                        "description": ""
                    }
                ]
            },
            {
                "title": "Estabilizador",
                "specs": [
                    {
                        "key": "Carga máxima para conector de un solo estabilizador",
                        "value": "1400 g\u003cbr\u003e\u003cbr\u003e Si se exceden los 950 g, la vida útil del amortiguador de estabilizador se reducirá de 1000 horas a 400 horas.",
                        "description": ""
                    },
                    {
                        "key": "Carga máxima para conector de doble estabilizador",
                        "value": "950 g",
                        "description": ""
                    },
                    {
                        "key": "Carga máxima para el conector del tercer estabilizador",
                        "value": "3 kg para puerto de liberación rápida, 6 kg para cierre de tornillo",
                        "description": ""
                    },
                    {
                        "key": "Carga máxima para conector del estabilizador Zenmuse L3",
                        "value": "\u003chtml\u003e\u003chtml\u003e2100 g\u003cbr\u003e\u003cbr\u003e \u003csup\u003eSi se exceden los 1600 g, la vida útil del amortiguador de estabilizador se reducirá de 1000 horas a 400 horas.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    }
                ]
            },
            {
                "title": "Detección",
                "specs": [
                    {
                        "key": "Tipo de detección",
                        "value": "Sistema de visión binocular omnidireccional (vista envolvente gracias a sensores de visión de ojo de pez a todo color)\u003cbr\u003e\u003cbr\u003eLiDAR rotativo horizontal, LiDAR superior y sensor de rango infrarrojo 3D inferior\u003cbr\u003e\u003cbr\u003eRadar mmWave de seis direcciones",
                        "description": ""
                    },
                    {
                        "key": "Delantera",
                        "value": "Rango de medición: 0.4-21 m\u003cbr\u003e Alcance de detección: 0.4-200 m\u003cbr\u003eCampo de visión: 90° (horizontal), 90° (vertical)",
                        "description": ""
                    },
                    {
                        "key": "Trasera",
                        "value": "Rango de medición: 0.4-21 m\u003cbr\u003e Alcance de detección: 0.4-200 m\u003cbr\u003eCampo de visión: 90° (horizontal), 90° (vertical)",
                        "description": ""
                    },
                    {
                        "key": "Lateral",
                        "value": "Rango de medición: 0.6-21 m\u003cbr\u003eAlcance de detección: 0.5-200 m\u003cbr\u003eCampo de visión: 90° (horizontal), 90° (vertical)",
                        "description": ""
                    },
                    {
                        "key": "Inferior",
                        "value": "Rango de medición: 0.5-19 m\u003cbr\u003eEl FOV de la parte delantera y trasera es 160° y 105° a la derecha e izquierda.",
                        "description": ""
                    },
                    {
                        "key": "Entorno de funcionamiento",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003eDelantero, trasero, izquierdo, derecho y superior:\u003cbr\u003eTextura delicada en la superficie, luz adecuada. \u003cbr\u003e\u003cbr\u003eInferior:\u003cbr\u003eEl terreno tiene grandes texturas y suficientes condiciones de iluminación*, con una superficie de reflectividad difusa y una reflectividad mayor que 20 % (como paredes, árboles, personas, etc.). \u003cbr\u003e\u003cbr\u003e\u003csup\u003e* Suficientes condiciones de iluminación hacen referencia a la iluminación que no es menor que la de la escena de luces en la ciudad de noche.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "LiDAR rotativa",
                        "value": "Rango de medición estándar: De 0.5 a 100 m a 100,000 lux con un objetivo de reflectividad del 10 %\u003cbr\u003eRango de medición para línea de energía: 35 m a 30° a 10,000 lux para cable de aluminio con núcleo de acero de 21.6 mm con un ángulo de inclinación relativo del cuerpo de 30° hacia la izquierda y derecha\u003cbr\u003eCampo de visión: 360° (horizontal), 58° (vertical)\u003cbr\u003eFrecuencia de puntos: 520,000 puntos/segundo\u003cbr\u003eLongitud de onda del láser: 905 nm\u003cbr\u003eClase de seguridad ocular: Clase 1 (IEC60825-1:2014), seguro para los ojos",
                        "description": ""
                    },
                    {
                        "key": "LiDAR superior (ToF 3D)",
                        "value": "0.5-25 m por la noche (reflectividad \u003e 10 %)\u003cbr\u003eEl FOV hacia arriba y abajo es 60° y 60° a la derecha e izquierda.",
                        "description": ""
                    },
                    {
                        "key": "Sensor de infrarrojos 3D inferior",
                        "value": "Rango de medición: 0.3-8 m (reflectividad \u003e 10 %)\u003cbr\u003eEl FOV hacia el frente y la parte trasera es de 60° y 60° a la derecha e izquierda.",
                        "description": ""
                    },
                    {
                        "key": "Radar mmWave",
                        "value": "\u003chtml\u003e\u003chtml\u003eRango de medición para línea de energía:\u003cbr\u003e36 m para un cable de aluminio con núcleo de acero de 12 mm\u003cbr\u003e50 m para un cable de aluminio con núcleo de acero de 21.6 mm\u003cbr\u003eCampo de visión: ± 45° (horizontal y vertical)\u003cbr\u003e\u003cbr\u003e\u003csup\u003ePuede que la función de radar mmWave no esté disponible o esté restringida en algunos países o regiones. Consulta la legislación y las normativas locales para obtener más información.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    }
                ]
            },
            {
                "title": "Cámara FPV",
                "specs": [
                    {
                        "key": "Resolución",
                        "value": "1080p",
                        "description": ""
                    },
                    {
                        "key": "Campo de visión",
                        "value": "Campo de visión diagonal: 150°\u003cbr\u003eCampo de visión horizontal: 139.6°\u003cbr\u003eCampo de visión vertical: 95.3°",
                        "description": ""
                    },
                    {
                        "key": "Tasa de fotogramas",
                        "value": "30 fps",
                        "description": ""
                    },
                    {
                        "key": "Visión nocturna",
                        "value": "Grado Starlight",
                        "description": ""
                    }
                ]
            },
            {
                "title": "Transmisión de vídeo",
                "specs": [
                    {
                        "key": "Sistema de transmisión de vídeo",
                        "value": "Sistema de transmisión de vídeo mejorado DJI O4 Enterprise",
                        "description": ""
                    },
                    {
                        "key": "Calidad de la retransmisión en directo",
                        "value": "Control remoto: 3 canales, 1080p/30 fps",
                        "description": ""
                    },
                    {
                        "key": "Frecuencia de funcionamiento y potencia del transmisor (PIRE)",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e902-928 MHz: \u003c30 dBm (FCC), \u003c16 dBm (MIC)\u003cbr\u003e1.430-1.444 GHz: \u003c35 dBm (SRRC)\u003cbr\u003e2.400-2.4835 GHz: \u003c33 dBm (FCC), \u003c20 dBm (CE/SRRC/MIC)\u003cbr\u003e5.150-5.250 GHz: \u003c23 dBm (FCC/CE)\u003cbr\u003e5.725-5.850 GHz: \u003c33 dBm (FCC), \u003c14 dBm (CE), \u003c30 dBm (SRRC)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa frecuencia de funcionamiento permitida varía entre países y regiones. Consulta la legislación y las normativas locales para obtener más información.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Alcance máx. de transmisión (sin obstáculos, libre de interferencias)",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e40 km (FCC)\u003cbr\u003e20 km (CE/SRRC/MIC)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMediciones obtenidas en un entorno sin obstáculos ni interferencias. Los datos anteriores muestran el alcance de comunicación más lejano para vuelos en un sentido y sin retorno bajo cada estándar. Durante el vuelo, presta atención al recordatorio de RPO en la aplicación DJI Pilot 2.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Distancia máx. de transmisión (con interferencias)",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003eInterferencias fuertes (centros urbanos, áreas residenciales, etc.): aprox. 1.5-6 km\u003cbr\u003eInterferencias intermedias (áreas suburbanas, parques urbanos, etc.): aprox. 6-15 km\u003cbr\u003eInterferencias débiles (espacios abiertos, áreas remotas, etc.): aprox. 15-40 km\u003cbr\u003e\u003cbr\u003e\u003csup\u003eDatos probados bajo los estándares de la FCC, en entornos sin obstáculos y con interferencias típicas. Es meramente orientativo y no proporciona garantía sobre la distancia de vuelo real.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Velocidad máx. de descarga",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003eModo Estándar: 80 Mb/s de transmisión\u003cbr\u003eReproducción y descarga:  \u003c 25 Mb/s\u003cbr\u003eTasa de bits de un solo canal: ≤ 12 Mb/s\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa información de arriba se midió bajo condiciones donde la aeronave y el control remoto estaban cerca sin interferencia.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Antena",
                        "value": "Antena WLAN × 8: 6 antenas polarizadas verticalmente y 2 antenas polarizadas horizontalmente\u003cbr\u003eAntena sub2G × 2: 2 antenas polarizadas verticalmente\u003cbr\u003eAntena 4G × 4\u003cbr\u003e\u003cbr\u003eModo de funcionamiento: 2T4R",
                        "description": ""
                    },
                    {
                        "key": "Otros",
                        "value": "Admite modo de control dual y adaptador celular 2 de 2 canales",
                        "description": ""
                    }
                ]
            },
            {
                "title": "Batería",
                "specs": [
                    {
                        "key": "Modelo",
                        "value": "TB100",
                        "description": ""
                    },
                    {
                        "key": "Capacidad",
                        "value": "20 254 mAh",
                        "description": ""
                    },
                    {
                        "key": "Voltaje estándar",
                        "value": "48.23 V",
                        "description": ""
                    },
                    {
                        "key": "Voltaje máx. de carga",
                        "value": "54.6 V",
                        "description": ""
                    },
                    {
                        "key": "Tipo de celda",
                        "value": "Li-ion 13S",
                        "description": ""
                    },
                    {
                        "key": "Energía",
                        "value": "977 Wh",
                        "description": ""
                    },
                    {
                        "key": "Peso",
                        "value": "4720 ± 20 g",
                        "description": ""
                    },
                    {
                        "key": "Temperatura de recarga",
                        "value": "De 5 a 45 °C (de 41 a 113 °F)",
                        "description": ""
                    },
                    {
                        "key": "Temperatura de descarga",
                        "value": "De −20 a 75 °C (de −4 a 167 °F)",
                        "description": ""
                    },
                    {
                        "key": "Calentamiento de baterías",
                        "value": "Batería única: Compatible\u003cbr\u003e Batería a bordo: Compatible Estación de baterías: Compatible",
                        "description": ""
                    },
                    {
                        "key": "Tasa de descarga",
                        "value": "4C",
                        "description": ""
                    },
                    {
                        "key": "Potencia de carga máx.",
                        "value": "2C",
                        "description": ""
                    },
                    {
                        "key": "Carga a baja temperatura",
                        "value": "Admite autocalentamiento para cargar en bajas temperaturas",
                        "description": ""
                    },
                    {
                        "key": "Recuento de ciclos",
                        "value": "400",
                        "description": ""
                    }
                ]
            },
            {
                "title": "Estación de baterías inteligentes",
                "specs": [
                    {
                        "key": "Modelo",
                        "value": "BS100",
                        "description": ""
                    },
                    {
                        "key": "Peso neto",
                        "value": "11.8 kg",
                        "description": ""
                    },
                    {
                        "key": "Dimensiones",
                        "value": "605 × 410 × 250 mm (la. × an. × al.)",
                        "description": ""
                    },
                    {
                        "key": "Baterías compatibles",
                        "value": "Batería de vuelo inteligente TB100, batería con cable TB100C\u003cbr\u003eBatería WB37",
                        "description": ""
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −20 a 40 °C (de −4 a 104 °F)",
                        "description": ""
                    },
                    {
                        "key": "Entrada",
                        "value": "100-240 V (CA), 50-60 Hz, 10 A",
                        "description": ""
                    },
                    {
                        "key": "Salida",
                        "value": "Interfaz de batería TB100:\u003cbr\u003e100-110 V: Aprox. 1185 W\u003cbr\u003e110-180 V: Aprox. 1474 W\u003cbr\u003e180-240 V: Aprox. 2184 W\u003cbr\u003e\u003cbr\u003eInterfaz de batería WB37:\u003cbr\u003e100-240 V: Aprox. 52 W\u003cbr\u003e\u003cbr\u003eUSB-C:\u003cbr\u003e5.0 V 3.0 A, 9.0 V 3.0 A, 12.0 V 3.0 A, 15.0 V 3.0 A, 20.0 V 3.25 A",
                        "description": ""
                    },
                    {
                        "key": "Número de canales de carga",
                        "value": "Tres baterías TB100 y dos baterías WB37",
                        "description": ""
                    },
                    {
                        "key": "Método de carga",
                        "value": "Modo listo para volar 90 %; Modo estándar 100 %\u003cbr\u003eAdmite el modo Carga rápida y el modo silencioso",
                        "description": ""
                    },
                    {
                        "key": "Tiempo de carga",
                        "value": "\u003chtml\u003e\u003chtml\u003eBatería TB100/TB100C del 0 % al 100 %:\u003cbr\u003e\u003cbr\u003e220 V: 45 minutos (Modo de carga rápida); 110 minutos (Modo silencioso)\u003cbr\u003e\u003cbr\u003e110 V: 70 minutos (Modo de carga rápida); 110 minutos (Modo silencioso)\u003cbr\u003e\u003cbr\u003e\u003cbr\u003e\u003csup\u003eEl tiempo de carga se mide en un entorno de prueba con una temperatura de 25 °C (77 °F).\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    }
                ]
            },
            {
                "title": "DJI RC Plus 2 Enterprise Enhanced",
                "specs": [
                    {
                        "key": "Sistema de transmisión de vídeo",
                        "value": "Sistema de transmisión de vídeo mejorado DJI O4 Enterprise",
                        "description": ""
                    },
                    {
                        "key": "Alcance máx. de transmisión (sin obstáculos, libre de interferencias)",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e40 km (FCC)\u003cbr\u003e20 km (CE/SRRC/MIC)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMediciones obtenidas en un entorno sin obstáculos ni interferencias. Los datos anteriores muestran el alcance de comunicación más lejano para vuelos en un sentido y sin retorno bajo cada estándar. Durante el vuelo, presta atención al recordatorio de RPO en la aplicación DJI Pilot 2.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Frecuencia de funcionamiento y potencia del transmisor (PIRE)",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e902-928 MHz: \u003c30 dBm (FCC), \u003c16 dBm (MIC)\u003cbr\u003e2.400-2.4835 GHz: \u003c33 dBm (FCC), \u003c20 dBm (CE/SRRC/MIC)\u003cbr\u003e5.150-5.250 GHz: \u003c23 dBm (FCC/CE)\u003cbr\u003e5.725-5.850 GHz: \u003c33 dBm (FCC), \u003c14 dBm (CE), \u003c30 dBm (SRRC)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa frecuencia de funcionamiento permitida varía entre países y regiones. Consulta la legislación y las normativas locales para obtener más información.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Antena",
                        "value": "2T4R, antena multihaz de alta ganancia para 2,4 GHz/5,8 GHz\u003cbr\u003eMódulo sub2G: 2T2R",
                        "description": ""
                    },
                    {
                        "key": "Transmisión aumentada",
                        "value": "Admite el adaptador celular 2 DJI",
                        "description": ""
                    },
                    {
                        "key": "Protocolo de Wi-Fi",
                        "value": "Wi-Fi Direct, pantalla inalámbrica, IEEE 802.11 a/b/g/n/ac/ax\u003cbr\u003e\u003cbr\u003eAdmite Wi-Fi MIMO 2×2, soporte de doble banda simultánea (DBS) para MAC dual, con tasas de datos de hasta 1774,5 Mbps (2×2 + 2×2 11ax doble banda simultánea)",
                        "description": ""
                    },
                    {
                        "key": "Frecuencia de funcionamiento del Wi-Fi",
                        "value": "\u003chtml\u003e\u003chtml\u003e2.4000-2.4835 GHz\u003cbr\u003e5.150-5.250 GHz\u003cbr\u003e5.725-5.850 GHz\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLas bandas de frecuencias de 5.8 y 5.2 GHz están prohibidas en algunos países. En algunos países, la frecuencia de 5.2 GHz está permitida únicamente para uso en interiores. Consulta la legislación y las normativas locales para obtener más información.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Potencia del transmisor de Wi-Fi (PIRE)",
                        "value": "2.4 GHz: \u003c26 dBm, \u003c20 dBm (CE/SRRC/MIC)\u003cbr\u003e5.1 GHz: \u003c23 dBm (FCC/CE/SRRC/MIC)\u003cbr\u003e5.8 GHz: \u003c23 dBm (FCC/SRRC), \u003c14 dBm (CE)",
                        "description": ""
                    },
                    {
                        "key": "Protocolo de Bluetooth",
                        "value": "Bluetooth 5.2",
                        "description": ""
                    },
                    {
                        "key": "Frecuencia de funcionamiento de Bluetooth",
                        "value": "2.400-2.4835 GHz",
                        "description": ""
                    },
                    {
                        "key": "Potencia del transmisor de Bluetooth (PIRE)",
                        "value": "\u003c10 dBm",
                        "description": ""
                    },
                    {
                        "key": "Resolución de la pantalla",
                        "value": "1920 × 1200",
                        "description": ""
                    },
                    {
                        "key": "Tamaño de la pantalla",
                        "value": "7.02 pulgadas",
                        "description": ""
                    },
                    {
                        "key": "Tasa de fotogramas de la pantalla",
                        "value": "60 fps",
                        "description": ""
                    },
                    {
                        "key": "Brillo",
                        "value": "1400 nits",
                        "description": ""
                    },
                    {
                        "key": "Control de la pantalla táctil",
                        "value": "Multitoque de 10 puntos",
                        "description": ""
                    },
                    {
                        "key": "Batería integrada",
                        "value": "Batería de ion-litio 18650 densidad de energía alta, 2S2P (6500 mAh a 7,2 V), 46,8 Wh",
                        "description": ""
                    },
                    {
                        "key": "Batería externa",
                        "value": "Opcional, WB37 (4920 mAh a 7,6 V), 37 Wh",
                        "description": ""
                    },
                    {
                        "key": "Tipo de carga",
                        "value": "Admite carga rápida PD con una especificación máxima de cargador USB tipo C de 20 V/3.25 A.",
                        "description": ""
                    },
                    {
                        "key": "Capacidad de almacenamiento",
                        "value": "RAM 8G + ROM 128G UFS + almacenamiento ampliable con tarjeta microSD",
                        "description": ""
                    },
                    {
                        "key": "Tiempo de carga",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e2 horas de batería interna; 2 horas para batería interna más externa.\u003cbr\u003e\u003cbr\u003e\u003csup\u003eCuando el control remoto está desactivado y utiliza un cargador DJI estándar.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Tiempo de ejecución de batería interna",
                        "value": "3.8 horas",
                        "description": ""
                    },
                    {
                        "key": "Tiempo de ejecución de batería externa",
                        "value": "3.2 horas",
                        "description": ""
                    },
                    {
                        "key": "Puerto de salida",
                        "value": "HDMI 1.4",
                        "description": ""
                    },
                    {
                        "key": "Indicadores",
                        "value": "LED de estado, LED de nivel de batería, LED de estado de conexión; brillo ajustable según la luz ambiental.",
                        "description": ""
                    },
                    {
                        "key": "Altavoz",
                        "value": "Admite timbre",
                        "description": ""
                    },
                    {
                        "key": "Audio",
                        "value": "MIC de grupo",
                        "description": ""
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −20 a 50 °C (de −4 a 122 °F)",
                        "description": ""
                    },
                    {
                        "key": "Temperatura de almacenamiento",
                        "value": "En el plazo de un mes: De −30 °C a 45 °C (de −22 °F a 140 °F)\u003cbr\u003eDe uno a tres meses: De −30 °C a 35 °C (de −22 °F a 113 °F)\u003cbr\u003eDe tres meses a un año: De −30 °C a 30 °C (de −22 °F a 86 °F)",
                        "description": ""
                    },
                    {
                        "key": "Temperatura de carga",
                        "value": "De 5 a 40 °C (de 41 a 104 °F)",
                        "description": ""
                    },
                    {
                        "key": "Modelos de aeronaves compatibles",
                        "value": "Matrice 400",
                        "description": ""
                    },
                    {
                        "key": "Sistemas globales de navegación por satélite",
                        "value": "GPS + Galileo + BeiDou",
                        "description": ""
                    },
                    {
                        "key": "Dimensiones",
                        "value": "\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e\u003chtml\u003e268 × 163 × 94.5 mm (la. × an. × al.)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa anchura incluye una antena externa plegada, el grosor incluye bastones de manejo y controlador.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    },
                    {
                        "key": "Peso",
                        "value": "1,15 kg (sin batería externa)",
                        "description": ""
                    },
                    {
                        "key": "Modelo",
                        "value": "TKPL 2",
                        "description": ""
                    },
                    {
                        "key": "Versión del sistema",
                        "value": "Android 11",
                        "description": ""
                    },
                    {
                        "key": "Interfaces externas",
                        "value": "HDMI 1.4, SD 3.0, USB-C con soporte OTG, carga PD máxima de 65 W, USB-A con soporte USB 2.0",
                        "description": ""
                    },
                    {
                        "key": "Accesorios",
                        "value": "Soporte de cintura/banda opcional",
                        "description": ""
                    }
                ]
            },
            {
                "title": "Productos compatibles",
                "specs": [
                    {
                        "key": "Productos DJI compatibles con Matrice 400",
                        "value": "\u003chtml\u003e\u003chtml\u003eCámaras con estabilizador: Zenmuse L3, Zenmuse H30, Zenmuse H30T, Zenmuse L2 y Zenmuse P1\u003cbr\u003e Accesorios: Zenmuse S1 (foco para dron), Zenmuse V1 (altavoz para dron), Manifold 3, DJI RC Plus 2 módulo SDR sub2G*, Adaptador celular 2 DJI\u003cbr\u003e Estación RTK: estación multifunción D-RTK 3, estación móvil D-RTK 2\u003cbr\u003e Accesorios del ecosistema: DJI X-Port\u003cbr\u003e Kit de desarrollo DJI E-Port V2\u003cbr\u003e Kit de cable coaxial DJI E-Port V2\u003cbr\u003e Conjunto de adaptadores DJI SKYPORT V3\u003cbr\u003e Kit de cable coaxial DJI SKYPORT V3\u003cbr\u003e\u003cbr\u003e  \u003csup\u003e* La frecuencia de funcionamiento permitida varía entre países y regiones. Consulta la legislación y las normativas locales para obtener más información.\u003c/sup\u003e\u003c/html\u003e\u003c/html\u003e",
                        "description": ""
                    }
                ]
            }
        ]
    },
    {
        product: "matrice-4",
        specs:
            [
                {
                    "title": "Aeronave",
                    "specs": [
                        {
                            "key": "Peso de despegue (con hélices)",
                            "value": "\u003chtml\u003e1219 g*\n\u003cbr\u003e\u003csup\u003e*Peso estándar de la aeronave (incluidas la batería, las hélices y una tarjeta microSD). El peso real del producto puede variar debido a diferencias en los materiales de los lotes y a factores externos.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Peso de despegue (con hélices de ruido bajo)",
                            "value": "\u003chtml\u003e1229 g*\n\u003cbr\u003e\u003csup\u003e*Peso estándar de la aeronave (incluidas la batería, las hélices y una tarjeta microSD). El peso real del producto puede variar debido a diferencias en los materiales de los lotes y a factores externos.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Peso máx. de despegue",
                            "value": "Hélices estándares: 1420 g\nHélices de ruido bajo: 1430 g"
                        },
                        {
                            "key": "Dimensiones",
                            "value": "\u003chtml\u003ePlegado: 260,6 × 113,7 × 138,4 mm (la. × an. × al.)\nDesplegado: 307,0 × 387,5 × 149,5 mm (la. × an. × al.)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eDimensiones máximas sin las hélices.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Carga útil máx.",
                            "value": "200 g"
                        },
                        {
                            "key": "Tamaño de la hélice",
                            "value": "10,8 pulgadas"
                        },
                        {
                            "key": "Distancia diagonal entre ejes",
                            "value": "438,8 mm"
                        },
                        {
                            "key": "Velocidad máx. de ascenso",
                            "value": "10 m/s"
                        },
                        {
                            "key": "Velocidad de ascenso máxima con accesorios",
                            "value": "6 m/s"
                        },
                        {
                            "key": "Velocidad máx. de descenso",
                            "value": "8 m/s"
                        },
                        {
                            "key": "Velocidad de descenso máx. con accesorios",
                            "value": "6 m/s"
                        },
                        {
                            "key": "Velocidad horizontal máxima (al nivel del mar, sin viento)",
                            "value": "\u003chtml\u003e21 m/s\n21 m/s volando hacia delante, 18 m/s volando hacia atrás, 19 m/s volando a los lados\u003c/html\u003e"
                        },
                        {
                            "key": "Altitud máxima",
                            "value": "6000 m"
                        },
                        {
                            "key": "Altitud operativa máxima con carga útil",
                            "value": "4000 m"
                        },
                        {
                            "key": "Tiempo máx. de vuelo (sin viento)",
                            "value": "\u003chtml\u003e49 minutos (hélices estándares)\n46 minutos (Hélices de ruido bajo)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido con la aeronave volando a aproximadamente 9 m/s sin cargas útiles, en un entorno sin viento, hasta que el nivel de la batería llegó al 0 %. Los datos son solo de referencia. El tiempo de uso real puede variar según el modo de vuelo, los accesorios y el entorno. Presta atención a los recordatorios de la aplicación.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Tiempo máx. de vuelo estacionario (sin viento)",
                            "value": "\u003chtml\u003e42 minutos (hélices estándares)\n39 minutos (Hélices de ruido bajo)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido por las aeronaves manteniendo vuelo estacionario en un entorno sin viento, a nivel del mar y del 100 % del nivel de batería hasta el 0 %.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Distancia máxima de vuelo (sin viento)",
                            "value": "\u003chtml\u003e35 km (hélices estándares)\n32 km (hélices de ruido bajo)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido con la aeronave volando a aproximadamente 14 m/s sin cargas útiles, en un entorno sin viento, hasta que el nivel de la batería llegó al 0 %. Los datos son solo de referencia. El tiempo de uso real puede variar según el modo de vuelo, los accesorios y el entorno. Presta atención a los recordatorios de la aplicación.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Resistencia máx. al viento",
                            "value": "\u003chtml\u003e12 m/s*\n\u003cbr\u003e\u003csup\u003e*Resistencia máx. al viento durante el despegue y el aterrizaje.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Ángulo de inclinación máx.",
                            "value": "35°"
                        },
                        {
                            "key": "Temperatura de funcionamiento",
                            "value": "De −10 °C a 40 °C (de 14 °F a 104 °F)"
                        },
                        {
                            "key": "GNSS",
                            "value": "\u003chtml\u003eGPS + Galileo + BeiDou + GLONASS*\n\u003cbr\u003e\u003csup\u003e*(GLONASS solo es compatible cuando el módulo RTK está activado).\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Rango de precisión en vuelo estacionario (sin viento o con brisa)",
                            "value": "±0,1 m (con sistema de visión);\n±0,5 m (con GNSS);\u003cbr\u003e±0,1 m (con RTK)"
                        },
                        {
                            "key": "Precisión de GNSS de RTK",
                            "value": "RTK fijo:\n 1 cm + 1 ppm (horizontal); 1,5 cm + 1 ppm (vertical)"
                        },
                        {
                            "key": "Memoria interna",
                            "value": "N/D"
                        },
                        {
                            "key": "Puertos",
                            "value": "\u003chtml\u003eInterfaz de puerto electrónico × 1: Admite accesorios oficiales y dispositivos PSDK de terceros (no se admite el reemplazo)\nInterfaz de puerto electrónico Lite × 1: admite conexión USB al software de calibración de DJI y algunos dispositivos PSDK de terceros.\u003cbr\u003e\u003cbr\u003e\u003csup\u003eSe deben instalar los accesorios o módulos de expansión antes del encendido.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Modelo de hélice",
                            "value": "1157F (hélices estándares)\n1154F (hélices de ruido bajo)"
                        },
                        {
                            "key": "Baliza",
                            "value": "Integrada en la aeronave"
                        }
                    ]
                },
                {
                    "title": "Cámara ",
                    "specs": [
                        {
                            "key": "Sensor de imagen",
                            "value": "DJI Matrice 4T\nGran angular:\u003cbr\u003eCMOS de 1/1,3 pulgadas; píxeles efectivos: 48 MP\u003cbr\u003eTelecámara media:\u003cbr\u003eCMOS de 1/1,3 pulgadas; píxeles efectivos: 48 MP\u003cbr\u003eTelefoto:\u003cbr\u003eCMOS de 1/1,5 pulgadas; píxeles efectivos: 48 MP\u003cbr\u003e\u003cbr\u003eDJI Matrice 4E\u003cbr\u003eGran angular:\u003cbr\u003eCMOS de 4/3 pulgadas; píxeles efectivos: 20 MP\u003cbr\u003eTelecámara media:\u003cbr\u003eCMOS de 1/1,3 pulgadas; píxeles efectivos: 48 MP\u003cbr\u003eTelefoto:\u003cbr\u003eCMOS de 1/1,5 pulgadas; píxeles efectivos: 48 MP\u003cbr\u003e"
                        },
                        {
                            "key": "Objetivo",
                            "value": "DJI Matrice 4T\nCampo de visión: 82°\u003cbr\u003eDistancia focal equivalente: 24 mm\u003cbr\u003eApertura: f/1.7\u003cbr\u003eEnfoque: 1 m a ∞\u003cbr\u003e\u003cbr\u003eDJI Matrice 4E\u003cbr\u003eCampo de visión: 84°\u003cbr\u003eDistancia focal equivalente: 24 mm\u003cbr\u003eApertura: f/2.8-f/11\u003cbr\u003eEnfoque: 1 m a ∞\u003cbr\u003e\u003cbr\u003eTelecámara media\u003cbr\u003eCampo de visión: 35°\u003cbr\u003eDistancia focal equivalente: 70 mm\u003cbr\u003eApertura: f/2.8\u003cbr\u003eEnfoque: 3 m a ∞\u003cbr\u003e\u003cbr\u003eTelecámara\u003cbr\u003eCampo de visión: 15°\u003cbr\u003eDistancia focal equivalente: 168 mm\u003cbr\u003eApertura: f/2.8\u003cbr\u003eEnfoque: 3 m a ∞"
                        },
                        {
                            "key": "Rango ISO",
                            "value": "Modo Normal: ISO 100 a ISO 25 600\nModo de escena nocturna:\u003cbr\u003eMatrice 4T:\u003cbr\u003eCámara con gran angular: ISO 100 a ISO 409 600\u003cbr\u003eTelefoto media: ISO 100 a ISO 409 600\u003cbr\u003eTelefoto: ISO 100 a ISO 819 200\u003cbr\u003e\u003cbr\u003eMatrice 4E:\u003cbr\u003eCámara con gran angular: ISO 100 a ISO 204 800\u003cbr\u003eTelefoto media: ISO 100 a ISO 409 600\u003cbr\u003eTelefoto: ISO 100 a ISO 409 600\u003cbr\u003e\u003cbr\u003e"
                        },
                        {
                            "key": "Velocidad de obturación",
                            "value": "DJI Matrice 4T\n2-1/8000 s\u003cbr\u003e\u003cbr\u003eDJI Matrice 4E\u003cbr\u003eGran angular:\u003cbr\u003eObturador electrónico: 2/1-8000 s\u003cbr\u003eObturador mecánico: 2-1/2000 s\u003cbr\u003eTelefoto media: 2-1/8000 s\u003cbr\u003eTelefoto: 2-1/8000 s"
                        },
                        {
                            "key": "Tamaño de fotografía máximo",
                            "value": "DJI Matrice 4T\nGran angular: 8064 × 6048\u003cbr\u003eTelefoto media: 8064 × 6048\u003cbr\u003eTelefoto: 8192 × 6144\u003cbr\u003e\u003cbr\u003eDJI Matrice 4E\u003cbr\u003eGran angular: 5280 × 3956\u003cbr\u003eTelefoto media: 8064 × 6048\u003cbr\u003eTelefoto: 8192 × 6144"
                        },
                        {
                            "key": "Intervalo mínimo de foto",
                            "value": "DJI Matrice 4T: 0,7 s\nDJI Matrice 4E: 0,5 s"
                        },
                        {
                            "key": "Modos de fotografía fija",
                            "value": "DJI Matrice 4T:\nGran angular:\u003cbr\u003eÚnico: 12 MP/48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG: 0,7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eToma inteligente: 12 MP\u003cbr\u003ePanorámica: 12 MP (imagen sin procesar); 100 MP (imagen compuesta)\u003cbr\u003e\u003cbr\u003eTelecámara media:\u003cbr\u003eÚnico: 12 MP y 48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG:0,7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eToma inteligente: 12MP\u003cbr\u003e\u003cbr\u003eTelefoto:\u003cbr\u003eÚnico: 12 MP y 48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG: 0,7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eToma inteligente: 12 MP\u003cbr\u003e\u003cbr\u003e\u003cbr\u003eDJI Matrice 4E:\u003cbr\u003eÚnico: 20 MP\u003cbr\u003eCon temporizador: 20 MP\u003cbr\u003eJPEG: 0,5/0,7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eJPEG + RAW: 2/3/5/7/10/15/20/30/60 s\u003cbr\u003eToma inteligente: 20 MP\u003cbr\u003ePanorámica: 20 MP (imagen sin procesar); 100 MP (imagen compuesta)\u003cbr\u003e\u003cbr\u003eTelecámara media:\u003cbr\u003eÚnico: 12 MP y 48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG: 0,5/0,7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eToma inteligente: 12 MP\u003cbr\u003e\u003cbr\u003eTelefoto:\u003cbr\u003eÚnico: 12 MP y 48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG: 0,5/0,7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eToma inteligente: 12 MP"
                        },
                        {
                            "key": "Códec y resolución de vídeo",
                            "value": "Formato de codificación de vídeo: H.264/H.265\nEstrategia de código: CBR, VBR\u003cbr\u003eResolución:\u003cbr\u003e4K: 3840 × 2160 a 30 fps\u003cbr\u003eFHD: 1920 × 1080 a 30 fps"
                        },
                        {
                            "key": "Tasa de bits máx. de vídeo",
                            "value": "H.264: 60Mbps\nH.265: 40Mbps"
                        },
                        {
                            "key": "Sistemas de archivo compatibles",
                            "value": "exFAT"
                        },
                        {
                            "key": "Formato de fotografía",
                            "value": "DJI Matrice 4T: JPEG\n\u003cbr\u003eDJI Matrice 4E:\u003cbr\u003eGran angular: JPEG/DNG (RAW)\u003cbr\u003eTelecámara media: JPEG\u003cbr\u003eTelefoto: JPEG"
                        },
                        {
                            "key": "Formato de vídeo",
                            "value": "MP4 (MPEG-4 AVC/H.264)"
                        },
                        {
                            "key": "Zoom digital",
                            "value": "Telefoto:\n16x (zoom híbrido 112x)"
                        }
                    ]
                },
                {
                    "title": "Luz NIR auxiliar",
                    "specs": [
                        {
                            "key": "Iluminación por infrarrojos",
                            "value": "DJI Matrice 4T: \nCampo de visión: 5,7° ± 0,3°"
                        }
                    ]
                },
                {
                    "title": "Módulo láser",
                    "specs": [
                        {
                            "key": "Telémetro láser",
                            "value": "\u003chtml\u003eRango de medición: 1800 m (1 Hz) Reflectividad del objetivo a 20 %*\nRango de incidencia oblicua (1:5 de distancia oblicua): 600 m (1 Hz)\u003cbr\u003eZona ciega: 3-1 m\u003cbr\u003ePrecisión de medición de distancia:\u003cbr\u003e1-3 m: Error de sistema \u003c0,3 m, error aleatorio \u003c0,1 metros a 1σ\u003cbr\u003eOtras distancias: ± (0,2 + 0,0015 D) (D representa la distancia de medición en metros)\u003cbr\u003e\u003cbr\u003e\u003csup\u003e* Puede ocurrir una degradación de rendimiento si llueve o hay neblina\u003c/sup\u003e\u003c/html\u003e"
                        }
                    ]
                },
                {
                    "title": "Cámara térmica infrarroja",
                    "specs": [
                        {
                            "key": "Termógrafo",
                            "value": "\u003chtml\u003eDJI Matrice 4T: óxido de vanadio sin enfriar (VOx)\n\u003cbr\u003e\u003csup\u003eNO exponga los objetivos de la cámara de infrarrojos a fuentes de energía potentes, como el sol, lava o un rayo láser. De lo contrario, el sensor de la cámara podría quemarse y sufrir daños permanentes.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Resolución",
                            "value": "DJI Matrice 4T: 640 × 512"
                        },
                        {
                            "key": "Distancia entre píxeles",
                            "value": "DJI Matrice 4T: 12 μm"
                        },
                        {
                            "key": "Tasa de fotogramas",
                            "value": "DJI Matrice 4T: 30 Hz"
                        },
                        {
                            "key": "Objetivo",
                            "value": "DFOV de DJI Matrice 4T: 45° ± 0,3°\nLargo focal equivalente de DJI Matrice 4T: 53 mm\u003cbr\u003eApertura de DJI Matrice 4T: f/1.0\u003cbr\u003eEnfoque de DJI Matrice 4T: 5 m a ∞"
                        },
                        {
                            "key": "Sensibilidad",
                            "value": "DJI Matrice 4T: ≤50 mk a F1.0"
                        },
                        {
                            "key": "Método de medición de temperatura",
                            "value": "DJI Matrice 4T: Medición de punto, medición de área"
                        },
                        {
                            "key": "Rango de medición de temperatura",
                            "value": "DJI Matrice 4T:\nModo de alta ganancia: De −20 °C a 150 °C (de −4 °F a 302 °F) ()\u003cbr\u003eModo de baja ganancia: De 0 °C a 550 °C (de 32 °F a 1022 °F)"
                        },
                        {
                            "key": "Paleta",
                            "value": "DJI Matrice 4T:\nBlanco vivo/Negro vivo/Tinte/Hierro rojo/Hierro caliente/Ártico/Médico/Fulgurita/Arcoíris 1/Arcoíris 2"
                        },
                        {
                            "key": "Formato de fotografía",
                            "value": "DJI Matrice 4T: JPEG (8 bit), R-JPEG (16 bit)"
                        },
                        {
                            "key": "Resolución de vídeo",
                            "value": "DJI Matrice 4T:\n1280 × 1024 a 30 fps (superresolución habilitada, modo noche no activado)\u003cbr\u003eOtras condiciones: 640 × 512 a 30 fps"
                        },
                        {
                            "key": "Tasa de bits de vídeo",
                            "value": "DJI Matrice 4T:\n6.5 Mbps (H.264 640 × 512 a 30 fps)\u003cbr\u003e5 Mbps (H.265 640 × 512 a 30 fps)\u003cbr\u003e12 Mbps (H.264 1280 × 1024 a 30 fps)\u003cbr\u003e8 Mbps (H.265 1280 × 1024 a 30 fps)"
                        },
                        {
                            "key": "Formato de vídeo",
                            "value": "DJI Matrice 4T: MP4"
                        },
                        {
                            "key": "Modos de fotografía fija",
                            "value": "DJI Matrice 4T:\nÚnico: 1280 × 1024/640 × 512\u003cbr\u003eCon temporizador: 1280 × 1024/640 × 512\u003cbr\u003eJPEG: 0,7/1/2/3/5/7/10/15/20/30/60 s"
                        },
                        {
                            "key": "Resolución de foto",
                            "value": "DJI Matrice 4T:\nInfrarrojo: 1280 × 1024 (superresolución encendida)\u003cbr\u003e640 × 512 (superresolución apagada)"
                        },
                        {
                            "key": "Zoom digital",
                            "value": "DJI Matrice 4T: 28x"
                        },
                        {
                            "key": "Longitud de onda infrarroja",
                            "value": "DJI Matrice 4T: 8 μm a 14 μm"
                        },
                        {
                            "key": "Precisión de medición de temperatura infrarroja",
                            "value": "DJI Matrice 4T: Alta ganancia: ±2 °C o ±2 %, lo que sea mayor\nDJI Matrice 4T: Baja ganancia: ±5 °C o ±3 %, lo que sea más grande"
                        }
                    ]
                },
                {
                    "title": "Estabilizador",
                    "specs": [
                        {
                            "key": "Sistema de estabilización",
                            "value": "DJI Matrice 4T: 3 ejes (inclinación, rotación, paneo)\nDJI Matrice 4E: 3 ejes (inclinación, rotación, paneo)"
                        },
                        {
                            "key": "Rango mecánico",
                            "value": "DJI Matrice 4T\nLímites mecánicos del estabilizador:\u003cbr\u003eInclinación: De −140° a 113°\u003cbr\u003eRotación: De −52° a 52°\u003cbr\u003ePaneo: De −65° a 65°\u003cbr\u003eLímites suave:\u003cbr\u003eInclinación: De −90° a 35°\u003cbr\u003eRotación: De −47° a 47°\u003cbr\u003ePaneo: De −60° a 60°\u003cbr\u003e\u003cbr\u003eDJI Matrice 4E\u003cbr\u003eLímites mecánicos del estabilizador:\u003cbr\u003eInclinación: De −140° a 50°\u003cbr\u003eRotación: De −52° a 52°\u003cbr\u003ePaneo: De −65° a 65°\u003cbr\u003eLímites suave:\u003cbr\u003eInclinación: De −90° a 35°\u003cbr\u003eRotación: De −47° a 47°\u003cbr\u003ePaneo: De -60° a 60°"
                        },
                        {
                            "key": "Rango de rotación controlable",
                            "value": "DJI Matrice 4T\nInclinación: De −90° a 35°\u003cbr\u003ePaneo: No controlable\u003cbr\u003e\u003cbr\u003eDJI Matrice 4E\u003cbr\u003eInclinación: De −90° a 35°\u003cbr\u003ePaneo: No controlable"
                        },
                        {
                            "key": "Velocidad máx. de control (inclinación)",
                            "value": "100°/s"
                        },
                        {
                            "key": "Intervalo de vibración angular",
                            "value": "±0.007°"
                        },
                        {
                            "key": "Eje de desvío",
                            "value": "La operación manual no se controla\nEl programa de interfaz msdk se controla."
                        },
                        {
                            "key": "Índice de protección de entrada",
                            "value": "Nivel de protección no estándar"
                        },
                        {
                            "key": "Temperatura de funcionamiento",
                            "value": "Estándar: De -10 °C a 40 °C (de 14 °F a 104 °F)"
                        }
                    ]
                },
                {
                    "title": "Detección",
                    "specs": [
                        {
                            "key": "Tipo de detección",
                            "value": "Sistema de visión binocular omnidireccional, complementado con un sensor de infrarrojos 3D ubicado en la parte inferior de la aeronave."
                        },
                        {
                            "key": "Delantera",
                            "value": "Rango de medición binocular: 0,4-22,5 m\nRango de medición: 0,4-200 m\u003cbr\u003eVelocidad del sistema anticolisión: Velocidad de vuelo ≤21 m/s\u003cbr\u003eCampo de visión: 90° (horizontal), 135° (vertical)"
                        },
                        {
                            "key": "Trasera",
                            "value": "Rango de medición: 0,4-22,5 m\nRango de medición: 0,4-200 m\u003cbr\u003eVelocidad del sistema anticolisión: Velocidad de vuelo ≤21 m/s\u003cbr\u003eCampo de visión (FOV): −90° (horizontal), 135° (vertical)"
                        },
                        {
                            "key": "Lateral",
                            "value": "Rango de medición: 0,5-32 m\nRango de medición: 0,5-200 m\u003cbr\u003eVelocidad del sistema anticolisión: Velocidad de vuelo ≤21 m/s\u003cbr\u003eCampo de visión: 90° (horizontal), 90° (vertical)"
                        },
                        {
                            "key": "Inferior",
                            "value": "Rango de medición: 0,3-18,8 m\nVelocidad del sistema anticolisión: Velocidad de vuelo ≤10 m/s\u003cbr\u003eEl FOV de la parte delantera y trasera es 160° y 160° a la derecha e izquierda."
                        },
                        {
                            "key": "Entorno de funcionamiento",
                            "value": "\u003chtml\u003eDelantero, trasero, izquierdo, derecho y superior:\nTextura delicada en la superficie, luz adecuada.\u003cbr\u003e\u003cbr\u003eInferior:\u003cbr\u003eEl terreno tiene grandes texturas y suficientes condiciones de iluminación*, con una superficie de reflectividad difusa y una reflectividad mayor que 20 % (como paredes, árboles, personas, etc.).\u003cbr\u003e\u003cbr\u003e\u003csup\u003e*“Suficientes condiciones de iluminación” hace referencia a la iluminación que no es menor que la de la escena de luces en la ciudad de noche.\u003c/sup\u003e\u003c/html\u003e"
                        }
                    ]
                },
                {
                    "title": "Transmisión de vídeo",
                    "specs": [
                        {
                            "key": "Sistema de transmisión de vídeo",
                            "value": "O4 Enterprise"
                        },
                        {
                            "key": "Calidad de la retransmisión en directo",
                            "value": "Control remoto: 1080p/30 fps"
                        },
                        {
                            "key": "Frecuencia de funcionamiento",
                            "value": "\u003chtml\u003e2.400-2.4835 GHz\n2.400-2.4835 GHz\u003cbr\u003e5.725-5.850 GHz\u003cbr\u003e5.150-5.250 GHz (CE)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa frecuencia de funcionamiento permitida varía entre países y regiones. Consulta la legislación y las normativas locales para obtener más información.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Potencia del transmisor (PIRE)",
                            "value": "2.4 GHz: ≤33 dBm (FCC), ≤20 dBm (CE/SRRC/MIC)\n5.8 GHz: \u003c33 dBm (FCC), \u003c30 dB (SRRC) , \u003c14 dBm (CE)\u003cbr\u003e5.15-5.25: \u003c23 dBm (FCC/CE)"
                        },
                        {
                            "key": "Alcance máximo de transmisión (sin obstáculos, libre de interferencias)",
                            "value": "\u003chtml\u003e25 km (FCC)\n12 km (CE)\u003cbr\u003e12 km (SRRC)\u003cbr\u003e12 km (MIC)\u003cbr\u003e\u003cbr\u003e\u003csup\u003e*Mediciones obtenidas en un entorno sin obstáculos ni interferencias. Los datos anteriores muestran el alcance de comunicación más lejano para vuelos en un sentido y sin retorno bajo cada estándar. Durante el vuelo, presta atención al recordatorio de RPO en la aplicación DJI Pilot 2.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Distancia máx. de transmisión (con interferencias)",
                            "value": "\u003chtml\u003eFuerte interferencia: centros urbanos (aproximadamente de 1,5 km a 5 km)\nInterferencia media: áreas suburbanas (aproximadamente de 5 a 15 km)\u003cbr\u003eMicrointerferencia: suburbios/zonas costeras (aproximadamente de 15 a 25 km)\u003cbr\u003e\u003cbr\u003e\u003csup\u003e*Los datos se prueban bajo estándares de FCC en entornos sin obstáculos y con interferencias típicas. Solo funciona como referencia y no proporcionan una garantía en cuanto a la distancia de vuelo real.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Velocidad máx. de descarga",
                            "value": "\u003chtml\u003e20 MB/s\n\u003cbr\u003e\u003csup\u003eLa información de arriba se midió bajo condiciones donde la aeronave y el control remoto estaban cerca sin interferencia.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Latencia (según las condiciones del entorno y del dispositivo móvil)",
                            "value": "\u003chtml\u003e130 m\n\u003cbr\u003e\u003csup\u003eBajo condiciones sin interferencia y a corta distancia, el rendimiento de latencia cuando se capturó con un lente 1x.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Antena",
                            "value": "8 antenas, 2T4R"
                        },
                        {
                            "key": "Otros",
                            "value": "Compartimento del adaptador celular"
                        }
                    ]
                },
                {
                    "title": "Tarjeta de memoria",
                    "specs": [
                        {
                            "key": "Tarjetas SD compatibles",
                            "value": "Se requiere U3/Class10/V30 o superior, o usar una tarjeta de memoria de la lista de recomendadas."
                        },
                        {
                            "key": "Tarjetas microSD recomendadas",
                            "value": "MicroSDXC Lexar 1066x 64 GB U3 A2 V30\nMicroSDXC Lexar 1066x 128 GB U3 A2 V30\u003cbr\u003eMicroSDXC Lexar 1066x 256 GB U3 A2 V30\u003cbr\u003eMicroSDXC Lexar 1066x 512 GB U3 A2 V30\u003cbr\u003eKingston Canvas GO! MicroSDXC Plus 64 GB U3 A2 V30\u003cbr\u003eKingston Canvas GO! MicroSDXC Plus 128 GB U3 A2 V30\u003cbr\u003eKingston Canvas GO! MicroSDXC Plus 256 GB U3 A2 V30\u003cbr\u003eKingston Canvas GO! MicroSDXC Plus 512 GB U3 A2 V30"
                        }
                    ]
                },
                {
                    "title": "Batería de vuelo inteligente",
                    "specs": [
                        {
                            "key": "Capacidad",
                            "value": "6741 mAh"
                        },
                        {
                            "key": "Voltaje estándar",
                            "value": "14,76 V"
                        },
                        {
                            "key": "Voltaje máx. de carga",
                            "value": "17.0 V"
                        },
                        {
                            "key": "Tipo de celda",
                            "value": "Li-ion 4S"
                        },
                        {
                            "key": "Energía",
                            "value": "99.5 Wh"
                        },
                        {
                            "key": "Peso",
                            "value": "401 g"
                        },
                        {
                            "key": "Temperatura de recarga",
                            "value": "De 5 °C a 40 °C (de 41 °F a 104 °F)"
                        },
                        {
                            "key": "Tasa de descarga",
                            "value": "4C"
                        },
                        {
                            "key": "Potencia de carga máx.",
                            "value": "1.8C"
                        },
                        {
                            "key": "Admite carga de baja temperatura",
                            "value": "No compatible"
                        },
                        {
                            "key": "Recuento de ciclos",
                            "value": "200"
                        }
                    ]
                },
                {
                    "title": "Adaptador de corriente (100 W)",
                    "specs": [
                        {
                            "key": "Entrada",
                            "value": "100-240 V (CA), 50/60 Hz, 2,5 A"
                        },
                        {
                            "key": "Salida",
                            "value": "\u003chtml\u003eMáx. 100 W (total)\n\u003cbr\u003e\u003csup\u003eCuando se utilizan ambos puertos, la potencia de salida máxima de un puerto es de 82 W y el cargador asignará dinámicamente la potencia de salida de los dos puertos de acuerdo con la carga de energía.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Potencia nominal",
                            "value": "100 W"
                        }
                    ]
                },
                {
                    "title": "Estación de carga",
                    "specs": [
                        {
                            "key": "Entrada",
                            "value": "USB-C: 5-20 V, máx. 5 A"
                        },
                        {
                            "key": "Salida",
                            "value": "Interfaz de batería: 11,2 V a 17 V"
                        },
                        {
                            "key": "Potencia nominal",
                            "value": "100 W"
                        },
                        {
                            "key": "Tipo de recarga",
                            "value": "Cuatro baterías cargando en secuencia\nAdmite modo estándar (100 % SOC) y modo de espera (90 % SOC)"
                        },
                        {
                            "key": "Batería compatible",
                            "value": "Batería de vuelo inteligente serie DJI Matrice 4E/T"
                        },
                        {
                            "key": "Temperatura de carga",
                            "value": "De 5 °C a 40 °C (de 41 °F a 104 °F)"
                        }
                    ]
                },
                {
                    "title": "DJI RC Plus 2 Enterprise",
                    "specs": [
                        {
                            "key": "Sistema de transmisión de vídeo",
                            "value": "O4 Enterprise"
                        },
                        {
                            "key": "Alcance máximo de transmisión (sin obstáculos, libre de interferencias)",
                            "value": "\u003chtml\u003e25 km (FCC)\n12 km (CE)\u003cbr\u003e12 km (SRRC)\u003cbr\u003e12 km (MIC)\u003cbr\u003e\u003cbr\u003e\u003csup\u003e*Mediciones obtenidas en un entorno sin obstáculos ni interferencias. Los datos anteriores muestran el alcance de comunicación más lejano para vuelos en un sentido y sin retorno bajo cada estándar. Durante el vuelo, presta atención al recordatorio de RPO en la aplicación DJI Pilot 2.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Transmisión de la imagen de banda operativa",
                            "value": "\u003chtml\u003e2.4000-2.4835 GHz\nDe 5.725 a 5.850 GHz\u003cbr\u003eSolo receptor de 5.1 G\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa frecuencia de funcionamiento permitida varía entre países y regiones. Consulta la legislación y las normativas locales para obtener más información.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Antena",
                            "value": "Antena de alta ganancia integrada de multirayos 2T4R"
                        },
                        {
                            "key": "Potencia del transmisor de la transmisión de vídeo (PIRE)",
                            "value": "2.4 GHz: ＜33 dBm (FCC), ＜20 dBm (CE/SRRC/MIC)\n5.1 GHz: \u003c23 dBm (CE)\u003cbr\u003e5.8 GHz: \u003c33 dBm (FCC), \u003c14 dBm (CE), \u003c30 dBm (SRRC)"
                        },
                        {
                            "key": "Transmisión 4G",
                            "value": "Adaptador celular 2 DJI"
                        },
                        {
                            "key": "Protocolo de wifi",
                            "value": "Wi-Fi Direct, pantalla inalámbrica, IEEE 802.11a/b/g/n/ac/ax\nAdmite wifi MIMO 2 x 2, doble banda simultánea (DBS) con MAC dual, tasa de datos de hasta 1774.5 Mbps (2 × 2 + 2 × 2 11ax DBS)"
                        },
                        {
                            "key": "Banda de funcionamiento del wifi",
                            "value": "\u003chtml\u003e2.4000-2.4835 GHz\n5.150-5.250 GHz\u003cbr\u003e5.725-5.850 GHz\u003cbr\u003e\u003cbr\u003e\u003csup\u003e*Las bandas de frecuencias de 5.8 y 5.2 GHz están prohibidas en algunos países. En algunos países, la frecuencia de 5.2 GHz está permitida únicamente para uso en interiores.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Potencia del transmisor de Wi-Fi (PIRE)",
                            "value": "2.4 GHz: \u003c26 dBm (FCC), \u003c20 dBm (CE/SRRC/ MIC)\n5.1 GHz: \u003c23 dBm (FCC)\u003cbr\u003e5.8 GHz \u003c23 dBm (FCC/SRRC), \u003c14 dBm (CE)"
                        },
                        {
                            "key": "Protocolo de Bluetooth",
                            "value": "Bluetooth 5.2"
                        },
                        {
                            "key": "Frecuencia de funcionamiento de Bluetooth",
                            "value": "2.400-2.4835 GHz"
                        },
                        {
                            "key": "Potencia del transmisor de Bluetooth (PIRE)",
                            "value": "\u003c10 dBm"
                        },
                        {
                            "key": "Resolución de la pantalla",
                            "value": "1920 × 1200"
                        },
                        {
                            "key": "Tamaño de la pantalla",
                            "value": "7,02 pulgadas"
                        },
                        {
                            "key": "Tasa de fotogramas de la pantalla",
                            "value": "60 fps"
                        },
                        {
                            "key": "Brillo",
                            "value": "1400 nits"
                        },
                        {
                            "key": "Control de la pantalla táctil",
                            "value": "Multitoque de 10 puntos"
                        },
                        {
                            "key": "Batería integrada",
                            "value": "Batería de ion-litio 18650 densidad de energía alta, 2S2P (6500 mAh a 7,2 V), 46,8 Wh"
                        },
                        {
                            "key": "Batería externa",
                            "value": "Opcional, WB37 (4920 mAh a 7,6 V), 37 Wh"
                        },
                        {
                            "key": "Tipo de recarga",
                            "value": "Admite carga rápida PD con una especificación máxima de cargador USB tipo C de 20 V/3,25 A."
                        },
                        {
                            "key": "Capacidad de almacenamiento",
                            "value": "ROM 128 GB + almacenamiento ampliable con tarjeta microSD"
                        },
                        {
                            "key": "Tiempo de carga",
                            "value": "\u003chtml\u003e2 horas de batería interna o batería interna y externa.\n\u003cbr\u003e\u003csup\u003eCuando el control remoto está desactivado y utiliza un cargador DJI estándar.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Tiempo de ejecución de batería interna",
                            "value": "3,8 h"
                        },
                        {
                            "key": "Tiempo de ejecución de batería externa",
                            "value": "3,2 h"
                        },
                        {
                            "key": "Puerto de salida",
                            "value": "HDMI 1.4"
                        },
                        {
                            "key": "Indicadores",
                            "value": "Luz de estado, luz de potencia y luz de permiso, luz de tres colores, el brillo puede ajustarse según el brillo del ambiente."
                        },
                        {
                            "key": "Altavoz",
                            "value": "Admite timbre"
                        },
                        {
                            "key": "Audio",
                            "value": "MIC de grupo"
                        },
                        {
                            "key": "Temperatura de funcionamiento",
                            "value": "De −20 °C a 50 °C (D228 [de −4 °F a 122 °F])"
                        },
                        {
                            "key": "Temperatura de almacenamiento",
                            "value": "En el plazo de un mes: De −30 °C a 45 °C (de −22 °F a 113 °F)\nDe uno a tres meses: De −30 °C a 35 °C (de −22 °F a 95 °F)\u003cbr\u003eDe tres meses a un año: De −30 °C a 30 °C (de −22 °F a 86 °F)"
                        },
                        {
                            "key": "Temperatura de recarga",
                            "value": "De 5 °C a 40 °C (de 41 °F a 104 °F)"
                        },
                        {
                            "key": "Modelos de aeronaves compatibles",
                            "value": "Admite Matrice 4T/4E"
                        },
                        {
                            "key": "GNSS",
                            "value": "GPS, Galileo y BeiDou de triple modo, admite actualización de punto de origen dinámico."
                        },
                        {
                            "key": "Dimensiones",
                            "value": "\u003chtml\u003e268 × 163 × 94,5 mm (la. × an. × al.)\n\u003cbr\u003e\u003csup\u003eLa anchura incluye una antena externa plegada, el grosor incluye bastones de manejo y controlador.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Peso",
                            "value": "1,15 kg (sin batería externa)"
                        },
                        {
                            "key": "Modelo",
                            "value": "TKPL 2"
                        },
                        {
                            "key": "Versión del sistema",
                            "value": "Android 11"
                        },
                        {
                            "key": "Interfaces externas",
                            "value": "HDMI 1.4, SD3.0, tipo C, admite OTG, admite carga PD, máxima potencia de 65 W, USB-A admite interfaz USB 2.0."
                        },
                        {
                            "key": "Accesorios",
                            "value": "Soporte de cintura/banda opcional"
                        }
                    ]
                },
                {
                    "title": "Foco AL1 ",
                    "specs": [
                        {
                            "key": "Peso",
                            "value": "99 g (incluido el soporte)\nAprox. 91 g (incluido el soporte)"
                        },
                        {
                            "key": "Dimensiones",
                            "value": "95 × 164 × 30 mm (L × An × Al, incluido el soporte)\n79 × 164 × 28 mm (L × An × Al, sin soporte)"
                        },
                        {
                            "key": "Potencia máxima",
                            "value": "32 W"
                        },
                        {
                            "key": "Iluminación",
                            "value": "\u003chtml\u003e4,3 ± 0,2 lux a 100 metros, 17 ± 0,2 lux a 50 metros\n\u003cbr\u003e\u003csup\u003eLa información se midió en un entorno de laboratorio con la luz instalada de manera separada en la aeronave y en una temperatura ambiente de 25 °C.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Ángulo de iluminación efectivo",
                            "value": "23° (iluminación relativa del 10 %)"
                        },
                        {
                            "key": "Área de iluminación efectiva",
                            "value": "1300 metros cuadrados a 100 metros (10 % de iluminación relativa, modo normal)\n2200 metros cuadrados a 100 metros (10 % de iluminación central, modo campo de visión amplio)"
                        },
                        {
                            "key": "Modo de funcionamiento",
                            "value": "Admite los modos de iluminación constante y efecto estroboscópico"
                        },
                        {
                            "key": "Rango de diseño estructural de estabilizador",
                            "value": "Inclinación: De −140° a 50°"
                        },
                        {
                            "key": "Intervalo controlable:",
                            "value": "Inclinación: De −90° a 35°"
                        },
                        {
                            "key": "Velocidad máx. de control (inclinación)",
                            "value": "120°/s"
                        },
                        {
                            "key": "Precisión de alineación del estabilizador",
                            "value": "±0,1°"
                        },
                        {
                            "key": "Temperatura de funcionamiento",
                            "value": "De −20 °C a 50 °C (de -4 °F a 122 °F)"
                        },
                        {
                            "key": "Montura",
                            "value": "Tornillos de liberación rápida apretados a mano"
                        }
                    ]
                },
                {
                    "title": "Notas",
                    "specs": [
                        {
                            "key": "Peso",
                            "value": "92,5 g (incluido el soporte)\nAprox. 90 g (incluido el soporte)"
                        },
                        {
                            "key": "Dimensiones",
                            "value": "73 × 70 × 52 mm (L × An × Al, incluido el soporte)\n73 × 70 × 47 mm (L × An × Al, sin soporte)"
                        },
                        {
                            "key": "Potencia máxima",
                            "value": "15 W"
                        },
                        {
                            "key": "Volumen máximo",
                            "value": "\u003chtml\u003eA 1 metro, puede alcanzar los 114 decibelios (114 dB a 1 m).\n\u003cbr\u003e\u003csup\u003eLa información se mide en un entorno de laboratorio a 25 °C. Las condiciones reales pueden variar un poco debido a la versión del software, la fuente de audio, el entorno específico y otros factores. El efecto final depende del uso real.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Distancia de emisión efectiva",
                            "value": "\u003chtml\u003e300 m\n\u003cbr\u003e\u003csup\u003eLa información se mide en un entorno de laboratorio a 25 °C. Las condiciones reales pueden variar un poco debido a la versión del software, la fuente de audio, el entorno específico y otros factores. El efecto final depende del uso real.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Modo de emisión",
                            "value": "\u003chtml\u003eEmisión en tiempo real (compatible con supresión de eco*), emisión grabada, importación de medios (compatible con transmisión y reproducción simultáneas), conversión de texto a voz**\n\u003cbr\u003e\u003csup\u003e*Es necesario actualizar al firmware más reciente. \u003cbr\u003e**Ahora, solo admite chino e inglés.\u003c/sup\u003e\u003c/html\u003e"
                        },
                        {
                            "key": "Temperatura de funcionamiento",
                            "value": "De −20 °C a 50 °C (de -4 °F a 122 °F)"
                        },
                        {
                            "key": "Montura",
                            "value": "Tornillos de liberación rápida apretados a mano"
                        }
                    ]
                },

                {
                    "title": "Notas",
                    "specs": [
                        {
                            "key": "",
                            "value": "Los términos HDMI, HDMI High-Definition Multimedia Interface (Interfaz multimedia de alta definición), HDMI Trade Dress (diseño e imagen comercial HDMI) y los logotipos HDMI son marcas comerciales o marcas registradas de HDMI Licensing Administrator, Inc. \u003cbr\u003e\u003cbr\u003e \u003cimg src=\"https://terra-1-g.djicdn.com/851d20f7b9f64838a34cd02351370894/HDMI_logo_R_Black40.png\" height=\"50px\" width=\"125px\"\u003e\u003c/img\u003e",
                        }
                    ]
                }
            ]
    },
    {
        product: 'dock3',
        specs: [
            {
                "title": "Dock - General",
                "specs": [
                    {
                        "key": "Nombre del producto",
                        "value": "DJI Dock 3"
                    },
                    {
                        "key": "Peso total",
                        "value": "\u003chtml\u003e55 kg (sin aeronave)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eEl peso real del producto puede variar debido a diferencias en los materiales de los lotes y a factores externos. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Dimensiones",
                        "value": "\u003chtml\u003eCubierta del Dock abierta: 1760 × 745 × 485 mm (la. × an. × al.)\u003cbr\u003eCubierta del Dock cerrada: 640 × 745 × 770 mm (la. × an. × al.)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eTodos los datos incluyen el ancho del módulo RTK (160 mm), la altura del anemómetro (145 mm) y los soportes de la base de montaje (58 mm). \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Voltaje de entrada",
                        "value": "100-240 V (CA), 50-60 Hz"
                    },
                    {
                        "key": "Potencia de entrada",
                        "value": "Máximo 800 W"
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −30 a 50 °C (de −22 a 122 °F)"
                    },
                    {
                        "key": "Índice de protección de entrada",
                        "value": "IP56"
                    },
                    {
                        "key": "Número de drones alojados",
                        "value": "1"
                    },
                    {
                        "key": "Máx. velocidad del viento permisible para aterrizar",
                        "value": "12 m/s"
                    },
                    {
                        "key": "Máx. altitud operativa",
                        "value": "4500 m"
                    },
                    {
                        "key": "Frecuencia de recepción del satélite de la estación base RTK",
                        "value": "Recibe simultáneamente:\u003cbr\u003eGPS: L1 C/A, L2, L5\u003cbr\u003e BeiDou: B1l, B2l, B3l, B2a, B2b, B1C\u003cbr\u003e GLONASS: F1, F2\u003cbr\u003e Galileo: E1, E5a, E5b, E6\u003cbr\u003e QZSS: L1, L2, L5"
                    },
                    {
                        "key": "Precisión de posicionamiento de la estación base RTK",
                        "value": "Horizontal: 1 cm + 1 ppm (RMS)\u003cbr\u003eVertical: 2 cm + 1 ppm (RMS)"
                    }
                ]
            },
            {
                "title": "Dock - Rendimiento de carga",
                "specs": [
                    {
                        "key": "Voltaje de salida",
                        "value": "35 V DC"
                    },
                    {
                        "key": "Tiempo de carga",
                        "value": "\u003chtml\u003e27 minutos\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLos datos se midieron al cargar la aeronave (cuando estaba apagada) del 15 % al 95 % en un entorno a 25 °C (77 °F). \u003c/sup\u003e\u003c/html\u003e"
                    }
                ]
            },
            {
                "title": "Dock - Transmisión de vídeo",
                "specs": [
                    {
                        "key": "Frecuencia de funcionamiento",
                        "value": "\u003chtml\u003e2.400-2.4835 GHz\u003cbr\u003e5.150-5.250 GHz (CE: 5.170-5.250 GHz)\u003cbr\u003e5.725-5.850 GHz\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLas bandas de frecuencia operativas compatibles y su respectiva disponibilidad varían según el país o la región. Para más detalles, consulta las leyes y normativas locales. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Antena",
                        "value": "9 antenas integradas, 2T4R, permite cambio inteligente"
                    },
                    {
                        "key": "Potencia del transmisor (PIRE)",
                        "value": "2.4 GHz: \u003c33 dBm (FCC), \u003c20 dBm (CE/SRRC/MIC)\u003cbr\u003e5.2 GHz (CE: 5.170-5.250 GHz): \u003c23 dBm (FCC/CE)\u003cbr\u003e 5.8 GHz: \u003c33 dBm (FCC); \u003c14 dBm (CE); \u003c30 dBm (SRRC)"
                    }
                ]
            },
            {
                "title": "Dock - Sistema de aire acondicionado",
                "specs": [
                    {
                        "key": "Voltaje de funcionamiento",
                        "value": "48 V CD"
                    },
                    {
                        "key": "Tipo de aire acondicionado",
                        "value": "Aire acondicionado con compresor"
                    }
                ]
            },
            {
                "title": "Dock - Batería auxiliar",
                "specs": [
                    {
                        "key": "Capacidad de la batería",
                        "value": "12 Ah"
                    },
                    {
                        "key": "Voltaje de salida",
                        "value": "12 V"
                    },
                    {
                        "key": "Tipo de batería",
                        "value": "Batería de plomo y ácido"
                    },
                    {
                        "key": "Vida de la batería",
                        "value": "\u003chtml\u003e\u003e4 horas\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido con una batería auxiliar totalmente cargada en un entorno a 25 °C (77 °F). Tras una interrupción de energía, el Dock no permite funciones como: carga de la aeronave, aire acondicionado, calentamiento de la cubierta del Dock y calentamiento del anemómetro. Por favor, restaura la energía de inmediato. \u003c/sup\u003e\u003c/html\u003e"
                    }
                ]
            },
            {
                "title": "Dock - Acceso de red",
                "specs": [
                    {
                        "key": "Acceso a ethernet",
                        "value": "Puerto adaptable de Ethernet de 10/100/1000 Mb/s"
                    },
                    {
                        "key": "Acceso 4G",
                        "value": "\u003chtml\u003eRequiere el Adaptador celular 2 DJI\u003cbr\u003e\u003cbr\u003e\u003csup\u003eSe vende por separado. Este servicio no está disponible en algunos países y regiones. Consulta los detalles a tu distribuidor local. \u003c/sup\u003e\u003c/html\u003e"
                    }
                ]
            },
            {
                "title": "Dock - Sensor",
                "specs": [
                    {
                        "key": "Sensor de velocidad del viento",
                        "value": "Compatible"
                    },
                    {
                        "key": "Sensor de precipitaciones",
                        "value": "Compatible"
                    },
                    {
                        "key": "Sensor de temperatura ambiental",
                        "value": "Compatible"
                    },
                    {
                        "key": "Sensor de inmersión en agua",
                        "value": "Compatible"
                    },
                    {
                        "key": "Sensor de temperatura en cabina",
                        "value": "Compatible"
                    },
                    {
                        "key": "Sensor de humedad en cabina",
                        "value": "Compatible"
                    }
                ]
            },
            {
                "title": "Dock - Cámara de seguridad (externa)",
                "specs": [
                    {
                        "key": "Resolución",
                        "value": "1920×1080"
                    },
                    {
                        "key": "Campo de visión",
                        "value": "151°"
                    },
                    {
                        "key": "Luz auxiliar",
                        "value": "Luz blanca auxiliar"
                    }
                ]
            },
            {
                "title": "Dock - Cámara de seguridad (interna)",
                "specs": [
                    {
                        "key": "Resolución",
                        "value": "1920×1080"
                    },
                    {
                        "key": "Campo de visión",
                        "value": "151°"
                    },
                    {
                        "key": "Luz auxiliar",
                        "value": "Luz blanca auxiliar"
                    }
                ]
            },
            {
                "title": "Dock - Protección contra rayos",
                "specs": [
                    {
                        "key": "Puerto de alimentación de CA",
                        "value": "20 kA (valor nominal), cumple los requerimientos de nivel de protección EN 61643-11 Tipo 2 y IEC 61643-1 Clase Ⅱ"
                    },
                    {
                        "key": "Puerto ethernet",
                        "value": "10 kA (I\u003csup\u003etotal\u003c/sup\u003e), cumple los requerimientos de nivel de protección EN/IEC 61643-21 Categoría C"
                    }
                ]
            },
            {
                "title": "Dock - Software compatible",
                "specs": [
                    {
                        "key": "Aplicaciones",
                        "value": "Aplicación DJI Enterprise (se utiliza con teléfonos Android para el despliegue y la puesta en marcha)"
                    },
                    {
                        "key": "Plataforma en la nube",
                        "value": "FlightHub 2\u003cbr\u003eFlightHub 2 Versión On-Premises\u003cbr\u003eFlightHub 2 Sincronizar\u003cbr\u003eAPI en la nube de DJI"
                    }
                ]
            },
            {
                "title": "Dock - Capacidad de expansión",
                "specs": [
                    {
                        "key": "Computación Edge",
                        "value": "Admite comunicación de datos con conmutadores externos"
                    }
                ]
            },
            {
                "title": "Aeronave - General",
                "specs": [
                    {
                        "key": "Peso",
                        "value": "\u003chtml\u003e1850 g\u003cbr\u003e\u003cbr\u003e\u003csup\u003eEste valor incluye el peso de la batería, las hélices y una tarjeta microSD, pero no incluye cargas útiles de terceros. El peso real del producto puede variar debido a diferencias en los materiales de los lotes y a factores externos. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Peso máx. de despegue",
                        "value": "2090 g"
                    },
                    {
                        "key": "Dimensiones",
                        "value": "377.7 × 416.2 × 212.5 mm (la. × an. × al., sin hélices)"
                    },
                    {
                        "key": "Distancia entre ejes",
                        "value": "Distancia diagonal entre ejes: 498.5 mm\u003cbr\u003eDistancia entre ejes del motor delantero Izquierda-Derecha: 383.0 mm\u003cbr\u003eDistancia entre ejes del motor trasero Izquierda-Derecha: 343.0 mm\u003cbr\u003eDistancia entre ejes delante-detrás: 341.6 mm"
                    },
                    {
                        "key": "Velocidad máx. de ascenso",
                        "value": "6 m/s (modo Normal)\u003cbr\u003e10 m/s (modo Sport)"
                    },
                    {
                        "key": "Velocidad máx. de descenso",
                        "value": "6 m/s (modo Normal)\u003cbr\u003e8 m/s (modo Sport)"
                    },
                    {
                        "key": "Velocidad horizontal máx. (al nivel del mar, sin viento)",
                        "value": "\u003chtml\u003eModo Normal, con la detección de obstáculos activada: 15 m/s volando hacia delante, 12 m/s volando hacia atrás, 10 m/s volando a los lados\u003cbr\u003eModo Sport: 21 m/s volando hacia delante, 19 m/s volando hacia atrás, 15 m/s volando a los lados\u003cbr\u003e\u003cbr\u003e\u003csup\u003eCuando se utiliza con Dock DJI, solo se admite el modo Normal.\u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Resistencia máx. al viento",
                        "value": "Durante el funcionamiento: 12 m/s\u003cbr\u003eDurante el despegue/aterrizaje: 12 m/s"
                    },
                    {
                        "key": "Altitud máx. de despegue",
                        "value": "6500 m"
                    },
                    {
                        "key": "Tiempo máx. de vuelo",
                        "value": "\u003chtml\u003e54 minutos\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido en un entorno de prueba controlado. Las condiciones de prueba específicas son las siguientes: volando hacia delante a una velocidad constante de 12 m/s en un entorno de laboratorio sin viento, a 20 metros sobre el nivel del mar, en modo de foto (sin hacer fotos durante el vuelo), con la acción del sistema anticolisión establecida en Off, y del 100 % del nivel de batería hasta el 0 %. Los resultados pueden variar en función del entorno, el uso y la versión del firmware. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Tiempo máx. en vuelo estacionario",
                        "value": "\u003chtml\u003e47 minutos\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido con los drones de la Serie DJI Matrice 4D manteniendo vuelo estacionario en un entorno sin viento, a 20 metros sobre el nivel del mar y del 100 % del nivel de batería hasta el 0 %. Los resultados pueden variar en función del entorno, el uso y la versión del firmware. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Máx. radio operativo",
                        "value": "\u003chtml\u003e10 km\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido en un entorno a aproximadamente 25 °C (77 °F), con un nivel de batería seguro del 15 %, entorno sin viento, velocidad de vuelo de ida y vuelta de aproximadamente 15 m/s y 18 minutos de funcionamiento en vuelo estacionario. Los resultados pueden variar en función del entorno, el uso y la versión del firmware. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Distancia máx. de vuelo",
                        "value": "\u003chtml\u003e43 km\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido con Matrice 4D/4TD volando a una velocidad constante de 16 m/s en un entorno sin viento, a 20 metros sobre el nivel del mar y del 100 % del nivel de batería hasta el 0 %. Los resultados pueden variar en función del entorno, el uso y la versión del firmware. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Ángulo de inclinación máx.",
                        "value": "25° (modo Normal)\u003cbr\u003e30° (modo Sport)"
                    },
                    {
                        "key": "Velocidad angular máx.",
                        "value": "200°/s"
                    },
                    {
                        "key": "Sistemas globales de navegación por satélite",
                        "value": "GPS + BeiDou + Galileo + QZSS + GLONASS (QZSS y GLONASS son compatibles solo cuando el módulo RTK está activado.)"
                    },
                    {
                        "key": "Rango de precisión en vuelo estacionario (sin viento o con brisa)",
                        "value": "Vertical:\u003cbr\u003e±0.1 m (con posicionamiento visual)\u003cbr\u003e±0.5 m (con posicionamiento por GNSS)\u003cbr\u003e±0.1 m (con posicionamiento por RTK)\u003cbr\u003e\u003cbr\u003eHorizontal:\u003cbr\u003e±0.3 m (con posicionamiento visual)\u003cbr\u003e±0.5 m (con posicionamiento por GNSS)\u003cbr\u003e±0.1 m (con posicionamiento por RTK)"
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −20 a 50 °C (de −4 a 122 °F)"
                    },
                    {
                        "key": "Índice de protección de entrada",
                        "value": "IP55"
                    },
                    {
                        "key": "Modelo de motor",
                        "value": "2611"
                    },
                    {
                        "key": "Modelo de hélice",
                        "value": "Hélices 1364F plegables de reducción de ruido y anti-congelación"
                    },
                    {
                        "key": "Módulo RTK",
                        "value": "Integrado en la aeronave"
                    },
                    {
                        "key": "Baliza",
                        "value": "Integrado en la aeronave"
                    }
                ]
            },
            {
                "title": "Aeronave - Cámaras",
                "specs": [
                    {
                        "key": "Sensor de imagen",
                        "value": "DJI Matrice 4D:\u003cbr\u003eCámara gran angular: CMOS 4/3; píxeles efectivos: 20 MP\u003cbr\u003eTelecámara media: CMOS de 1/1.3 pulgadas; píxeles efectivos: 48 MP\u003cbr\u003eTelecámara: CMOS de 1/1.5 pulgadas; píxeles efectivos: 48 MP\u003cbr\u003e\u003cbr\u003eDJI Matrice 4TD:\u003cbr\u003eCámara gran angular: CMOS de 1/1.3 pulgadas; píxeles efectivos: 48 MP\u003cbr\u003eTelecámara media: CMOS de 1/1.3 pulgadas; píxeles efectivos: 48 MP\u003cbr\u003eTelecámara: CMOS de 1/1.5 pulgadas; píxeles efectivos: 48 MP"
                    },
                    {
                        "key": "Objetivo",
                        "value": "Cámara gran angular\u003cbr\u003eDJI Matrice 4D\u003cbr\u003eCampo de visión: 84° \u003cbr\u003eFormato equivalente: 24 mm\u003cbr\u003eApertura: f/2.8-f/11\u003cbr\u003eEnfoque: 1 m a ∞\u003cbr\u003eDJI Matrice 4TD\u003cbr\u003eCampo de visión: 82°\u003cbr\u003eFormato equivalente: 24 mm\u003cbr\u003eApertura: f/1.7\u003cbr\u003eEnfoque: 1 m a ∞\u003cbr\u003e\u003cbr\u003eTelecámara media\u003cbr\u003eCampo de visión: 35°\u003cbr\u003eFormato equivalente: 70 mm\u003cbr\u003eApertura: f/2.8\u003cbr\u003eEnfoque: 3 m a ∞\u003cbr\u003e\u003cbr\u003eTelecámara\u003cbr\u003eCampo de visión: 15°\u003cbr\u003eFormato equivalente: 168 mm\u003cbr\u003eApertura: f/2.8\u003cbr\u003eEnfoque: 3 m a ∞\u003cbr\u003e"
                    },
                    {
                        "key": "Desempañamiento del objetivo",
                        "value": "DJI Matrice 4D y DJI Matrice 4TD: Las cámaras gran angular, telecámara media y telecámara admiten el desempañamiento del objetivo"
                    },
                    {
                        "key": "Rango ISO",
                        "value": "Modo Normal: ISO 100 a ISO 25 600\u003cbr\u003e\u003cbr\u003eModo de escena nocturna:\u003cbr\u003e Matrice 4D\u003cbr\u003eCámara gran angular: ISO 100 a ISO 204 800\u003cbr\u003eTelecámara media: ISO 100 a ISO 409 600\u003cbr\u003eTelecámara: ISO 100 a ISO 409 600\u003cbr\u003eMatrice 4TD\u003cbr\u003eCámara gran angular: ISO 100 a ISO 409 600\u003cbr\u003eTelecámara media: ISO 100 a ISO 409 600\u003cbr\u003eTelecámara: ISO 100 a ISO 819 200"
                    },
                    {
                        "key": "Velocidad de obturación",
                        "value": "DJI Matrice 4D\u003cbr\u003eCámara gran angular: \u003cbr\u003eObturador electrónico: 2-1/8000 s\u003cbr\u003eObturador mecánico: 2-1/2000 s\u003cbr\u003eTelecámara media: \u003cbr\u003e2-1/8000 s\u003cbr\u003eTelecámara:\u003cbr\u003e2-1/8000 s\u003cbr\u003e\u003cbr\u003eDJI Matrice 4TD\u003cbr\u003e2-1/8000 s"
                    },
                    {
                        "key": "Tamaño máx. de imagen",
                        "value": "DJI Matrice 4D\u003cbr\u003eCámara gran angular: 5280 × 3956\u003cbr\u003eTelecámara media: 8064 × 6048\u003cbr\u003eTelecámara: 8192 × 6144\u003cbr\u003e\u003cbr\u003eDJI Matrice 4TD\u003cbr\u003eCámara gran angular: 8064 × 6048\u003cbr\u003eTelecámara media: 8064 × 6048\u003cbr\u003eTelecámara: 8192 × 6144"
                    },
                    {
                        "key": "Intervalo mínimo de foto",
                        "value": "DJI Matrice 4D: 0.5 s\u003cbr\u003eDJI Matrice 4TD: 0.7 s"
                    },
                    {
                        "key": "Modos de fotografía fija",
                        "value": "DJI Matrice 4D\u003cbr\u003eCámara gran angular:\u003cbr\u003eÚnico: 20 MP\u003cbr\u003eCon temporizador: 20 MP\u003cbr\u003eJPEG: 0.5/0.7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eJPEG + RAW: 2/3/5/7/10/15/20/30/60 s\u003cbr\u003eCaptura inteligente: 20 MP\u003cbr\u003ePanorámica: 20 MP (imagen sin procesar); 100 MP (imagen compuesta)\u003cbr\u003eTelecámara media:\u003cbr\u003eÚnico: 12 MP/48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG: 0.5/0.7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eCaptura inteligente: 12 MP\u003cbr\u003eTelecámara:\u003cbr\u003eÚnico: 12 MP/48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG: 0.5/0.7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eCaptura inteligente: 12 MP\u003cbr\u003e\u003cbr\u003eDJI Matrice 4TD\u003cbr\u003eCámara gran angular:\u003cbr\u003eÚnico: 12 MP/48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG: 0.7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eCaptura inteligente: 12 MP\u003cbr\u003ePanorámica: 12 MP (imagen sin procesar); 100 MP (imagen compuesta)\u003cbr\u003eTelecámara media:\u003cbr\u003eÚnico: 12 MP/48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG: 0.7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eCaptura inteligente: 12 MP\u003cbr\u003eTelecámara:\u003cbr\u003eÚnico: 12 MP/48 MP\u003cbr\u003eCon temporizador: 12 MP/48 MP\u003cbr\u003eJPEG: 0.7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eCaptura inteligente:12MP"
                    },
                    {
                        "key": "Códec y resolución de vídeo",
                        "value": "DJI Mavic 4D y DJI Mavic 4TD\u003cbr\u003eFormato de codificación de vídeo: H.264, H.265\u003cbr\u003eEstrategia de código: CBR, VBR\u003cbr\u003eResolución:\u003cbr\u003e4K: 3840 × 2160 a 30 fps\u003cbr\u003eFHD: 1920 × 1080 a 30 fps\u003cbr\u003e"
                    },
                    {
                        "key": "Tasa de bits de vídeo",
                        "value": "DJI Mavic 4D y DJI Mavic 4TD\u003cbr\u003eH264: 60 Mb/s\u003cbr\u003eH265: 40 Mb/s"
                    },
                    {
                        "key": "Sistemas de archivo compatibles",
                        "value": "exFAT"
                    },
                    {
                        "key": "Formato de fotografía",
                        "value": "DJI Matrice 4D:\u003cbr\u003eCámara gran angular: JPEG/DNG (RAW)\u003cbr\u003e Telecámara media: JPEG\u003cbr\u003e Telecámara: JPEG\u003cbr\u003e\u003cbr\u003e DJI Matrice 4TD: JPEG"
                    },
                    {
                        "key": "Formato de vídeo",
                        "value": "DJI Matrice 4D y DJI Matrice 4TD:MP4 (MPEG-4 AVC/H.264)"
                    },
                    {
                        "key": "Zoom digital",
                        "value": "Telecámara: 16x (zoom híbrido 112x)"
                    }
                ]
            },
            {
                "title": "Aeronave - Luz NIR auxiliar",
                "specs": [
                    {
                        "key": "Iluminación por infrarrojos",
                        "value": "DJI Matrice 4TD: \u003cbr\u003eCampo de visión: 5.7° ± 0.3°"
                    }
                ]
            },
            {
                "title": "Aeronave - Módulo láser",
                "specs": [
                    {
                        "key": "Telémetro láser",
                        "value": "\u003chtml\u003eRango de incidencia normal: 1800 m (1 Hz) Reflectividad del objetivo a 20 %*\u003cbr\u003eRango de incidencia oblicua (1:5 de distancia oblicua): 600 m (1 Hz)\u003cbr\u003eZona ciega: 1 m\u003cbr\u003ePrecisión de medición de distancia:\u003cbr\u003e1 m a 3 m: Error de sistema \u003c0.3 m, error aleatorio \u003c0.1 m a 1σ\u003cbr\u003eOtras distancias: ±(0.2+0.0015D) (Distancia en metros)\u003cbr\u003e\u003cbr\u003e\u003csup\u003e* Puede ocurrir una degradación de rendimiento si llueve o hay neblina.\u003c/sup\u003e\u003c/html\u003e"
                    }
                ]
            },
            {
                "title": "Aeronave - Cámara térmica infrarroja (DJI Matrice 4TD)",
                "specs": [
                    {
                        "key": "Termógrafo",
                        "value": "\u003chtml\u003eMicrobolómetro VOx no refrigerado\u003cbr\u003e\u003cbr\u003e\u003csup\u003eNO exponga los objetivos de la cámara de infrarrojos a fuentes de energía potentes, como el sol, lava o un rayo láser. De lo contrario, el sensor de la cámara podría quemarse y sufrir daños permanentes.\u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Resolución",
                        "value": "640 × 512"
                    },
                    {
                        "key": "Distancia entre píxeles",
                        "value": "12 μm"
                    },
                    {
                        "key": "Tasa de fotogramas",
                        "value": "30 Hz"
                    },
                    {
                        "key": "Objetivo",
                        "value": "DFOV: 45°\u003cbr\u003eFormato equivalente: 53 mm\u003cbr\u003eApertura: f/1.0\u003cbr\u003eEnfoque: 5 m a ∞"
                    },
                    {
                        "key": "Sensibilidad",
                        "value": "≤50 mK a F1.0"
                    },
                    {
                        "key": "Método de medición de temperatura",
                        "value": "Medición de punto, medición de área"
                    },
                    {
                        "key": "Rango de medición de temperatura",
                        "value": "De −40 a 150 °C (de −4 a 320 °F, modo de alta ganancia)\u003cbr\u003eDe 0 a 500 °C (de 32 a 932 °F, modo de baja ganancia)"
                    },
                    {
                        "key": "Paleta",
                        "value": "Blanco vivo/Negro vivo/Tinte/Hierro rojo/Hierro caliente/Ártico/Médico/Fulgurita/Arco iris 1/Arco iris 2"
                    },
                    {
                        "key": "Formato de fotografía",
                        "value": "JPEG (8 bits)\u003cbr\u003eR-JPEG (16 bits)"
                    },
                    {
                        "key": "Resolución de vídeo",
                        "value": "1280 × 1024 a 30 fps (función de Imagen Infrarroja UHR activada, modo de escena nocturna no activado)\u003cbr\u003eOtras condiciones: 640 × 512 a 30 fps"
                    },
                    {
                        "key": "Tasa de bits de vídeo",
                        "value": "6.5 Mbps (H.264 640 × 512 a 30 fps)\u003cbr\u003e5 Mbps (H.265 640 × 512 a 30 fps)\u003cbr\u003e12 Mbps (H.264 1280 × 1024 a 30 fps)\u003cbr\u003e8 Mbps (H.265 1280 × 1024 a 30 fps)"
                    },
                    {
                        "key": "Formato de vídeo",
                        "value": "MP4"
                    },
                    {
                        "key": "Modos de fotografía fija",
                        "value": "Único \u003cbr\u003eModo Normal: 640 × 512\u003cbr\u003eModo Imagen infrarroja UHR: 1280 × 1024\u003cbr\u003e\u003cbr\u003eCon temporizador\u003cbr\u003eModo Normal: 640 × 512, 0.7/1/2/3/5/7/10/15/20/30/60 s\u003cbr\u003eModo Imagen infrarroja UHR: 1280 × 1024, 0.7/1/2/3/5/7/10/15/20/30/60 s"
                    },
                    {
                        "key": "Zoom digital",
                        "value": "28×"
                    },
                    {
                        "key": "Longitud de onda infrarroja",
                        "value": "8-14 μm"
                    },
                    {
                        "key": "Precisión de medición de temperatura infrarroja",
                        "value": "Alta ganancia: ±2 °C o ±2 %, lo que sea mayor\u003cbr\u003eBaja ganancia: ±5 °C o ±3 %, lo que sea más grande"
                    }
                ]
            },
            {
                "title": "Aeronave - Estabilizador",
                "specs": [
                    {
                        "key": "Estabilización",
                        "value": "Estabilizador mecánico de 3 ejes (inclinación, rotación y paneo)"
                    },
                    {
                        "key": "Rango mecánico",
                        "value": "DJI Matrice 4D:\u003cbr\u003eInclinación: de -140° a +50°\u003cbr\u003eRotación: de -52° a +52°\u003cbr\u003ePaneo: de -65° a +65°\u003cbr\u003e\u003cbr\u003eDJI Matrice 4TD:\u003cbr\u003eInclinación: de -140° a +113°\u003cbr\u003eRotación: de -52° a +52°\u003cbr\u003ePaneo: de -65° a +65°"
                    },
                    {
                        "key": "Rango controlable",
                        "value": "\u003chtml\u003eDJI Matrice 4D\u003cbr\u003eInclinación: de -90° a +35°\u003cbr\u003ePaneo: no controlable\u003cbr\u003e\u003cbr\u003eDJI Matrice 4TD\u003cbr\u003eInclinación: de -90° a +90°*\u003cbr\u003ePaneo: no controlable\u003cbr\u003e\u003cbr\u003e\u003csup\u003e* Cuando el estabilizador del DJI Matrice 4TD se inclina hacia arriba en ángulos de entre +70° y +90°, la cámara gran angular, la telecámara media y la cámara térmica infrarroja quedarán obstruidas por el cuerpo de la aeronave.\u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Velocidad máx. de control (inclinación)",
                        "value": "100°/s"
                    },
                    {
                        "key": "Intervalo de vibración angular",
                        "value": "±0.005°"
                    }
                ]
            },
            {
                "title": "Aeronave - Detección",
                "specs": [
                    {
                        "key": "Tipo de detección",
                        "value": "Sistema de visión binocular omnidireccional, complementado con un sensor de infrarrojos 3D ubicado en la parte inferior de la aeronave."
                    },
                    {
                        "key": "Delantera",
                        "value": "Rango de medición: 0.5-20 m\u003cbr\u003eAlcance de detección: 0.5-200 m\u003cbr\u003eVelocidad de detección efectiva: Velocidad de vuelo ≤ 15 m/s\u003cbr\u003eCampo de visión: 95° horizontal, 90° vertical"
                    },
                    {
                        "key": "Trasera",
                        "value": "Rango de medición: 0,5-20 m\u003cbr\u003eVelocidad de detección efectiva: Velocidad de vuelo ≤ 12 m/s\u003cbr\u003eCampo de visión: 95° horizontal, 90° vertical"
                    },
                    {
                        "key": "Lateral",
                        "value": "Rango de medición: 0.5-16 m\u003cbr\u003eVelocidad de detección efectiva: Velocidad de vuelo ≤10 m/s\u003cbr\u003eCampo de visión: 90° horizontal, 90° vertical"
                    },
                    {
                        "key": "Superior",
                        "value": "Rango de medición: 0.5-20 m\u003cbr\u003eVelocidad de detección efectiva: Velocidad de vuelo ≤6 m/s\u003cbr\u003eCampo de visión: 95° delante y detrás, 90° izquierda y derecha"
                    },
                    {
                        "key": "Inferior",
                        "value": "Rango de medición: 0.5-16 m\u003cbr\u003eVelocidad de detección efectiva: Velocidad de vuelo ≤6 m/s\u003cbr\u003eCampo de visión: 90° delante y detrás, 95° izquierda y derecha"
                    },
                    {
                        "key": "Entorno de funcionamiento",
                        "value": "Delantero, trasero, superior e inferior: superficies con patrones reconocibles e iluminación adecuada (lux \u003e 0.1)\u003cbr\u003eLzquierda y derecha: superficie con reflectividad difusa \u003e 20 % (p. ej., muros, árboles, personas) e iluminación adecuada (lux \u003e 6)"
                    }
                ]
            },
            {
                "title": "Aeronave - Transmisión de vídeo",
                "specs": [
                    {
                        "key": "Sistema de transmisión de vídeo",
                        "value": "Transmisión DJI O4+ Enterprise"
                    },
                    {
                        "key": "Calidad de la retransmisión en directo",
                        "value": "720p/30 fps, 1080p/30 fps (con DJI RC Plus 2 Enterprise)\u003cbr\u003e540p/30fps, 720p/30fps, 1080p/30fps (con DJI Dock 3 y DJI FlightHub 2)"
                    },
                    {
                        "key": "Frecuencia de funcionamiento",
                        "value": "\u003chtml\u003e2.400-2.4835 GHz\u003cbr\u003e5.150-5.250 GHz (CE: 5.170-5.250 GHz)\u003cbr\u003e5.725-5.850 GHz\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLas bandas de frecuencia operativas compatibles y su respectiva disponibilidad varían según el país o la región. Para más detalles, consulta las leyes y normativas locales. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Alcance máximo de transmisión (sin obstáculos, libre de interferencias)",
                        "value": "\u003chtml\u003eFCC: 25 km\u003cbr\u003eCE: 12 km\u003cbr\u003eSRRC: 12 km\u003cbr\u003eMIC: 12 km\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido en un entorno exterior sin obstáculos ni interferencias. Los datos anteriores muestran el alcance de comunicación más lejano para vuelos en un sentido y sin retorno bajo cada estándar. Durante el vuelo, presta siempre atención a los recordatorios de RPO en DJI FlightHub 2 o en la aplicación DJI Pilot. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Distancia máxima de transmisión (sin obstáculos, con interferencias)",
                        "value": "\u003chtml\u003eInterferencias fuertes (centros urbanos, áreas residenciales, etc.): 1.5-5 km\u003cbr\u003eInterferencias intermedias (áreas suburbanas, parques urbanos, etc.): 5-15 km\u003cbr\u003eInterferencias débiles (espacios abiertos, áreas remotas, etc.): 15-25 km\u003cbr\u003e\u003cbr\u003e\u003csup\u003eDatos probados bajo los estándares de la FCC, en entornos sin obstáculos y con interferencias típicas. Es meramente orientativo y no proporciona garantía sobre la distancia de vuelo real. En situaciones de obstrucción, se recomienda instalar la versión de despliegue fijo del relé D-RTK 3. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Velocidad máx. de descarga",
                        "value": "\u003chtml\u003e20 MB/s (con DJI Dock 3)\u003cbr\u003e20 MB/s (con DJI RC Plus 2 Enterprise)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMedido en un entorno de laboratorio con pocas interferencias, en países/regiones que admiten 2.4 GHz y 5.8 GHz. Las velocidades de descarga pueden variar en función de las condiciones reales. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Latencia mínima",
                        "value": "La latencia de transmisión de vídeo desde la aeronave al Dock es de aproximadamente 100 milisegundos (influyen las condiciones ambientales).\u003cbr\u003e‌Las condiciones de la red y la configuración del ordenador influyen en la latencia de transmisión de vídeo desde el Dock a DJI FlightHub 2."
                    },
                    {
                        "key": "Antena",
                        "value": "8 antenas, 2T4R"
                    },
                    {
                        "key": "Potencia del transmisor (PIRE)",
                        "value": "2.4 GHz: \u003c33 dBm (FCC), \u003c20 dBm (CE/SRRC/MIC)\u003cbr\u003e5.1 GHz (CE: 5.170-5.250 GHz): \u003c23 dBm (FCC/CE)\u003cbr\u003e5.8 GHz: \u003c33 dBm (FCC/SRRC), \u003c14 dBm (CE)"
                    },
                    {
                        "key": "Otros",
                        "value": "\u003chtml\u003eAdmite el Adaptador celular 2 DJI\u003cbr\u003e\u003cbr\u003e\u003csup\u003eSe vende por separado. Este servicio no está disponible en algunos países y regiones. Consulta los detalles a tu distribuidor local. \u003c/sup\u003e\u003c/html\u003e"
                    }
                ]
            },
            {
                "title": "Aeronave - Almacenamiento",
                "specs": [
                    {
                        "key": "Tarjetas de memoria compatibles",
                        "value": "Aeronave:\u003cbr\u003eSon compatibles U3/Clase 10/V30 o superiores. A continuación, hay una lista de tarjetas microSD recomendadas."
                    },
                    {
                        "key": "Tarjetas microSD recomendadas",
                        "value": "MicroSDXC Lexar 1066x 64 GB U3 A2 V30\u003cbr\u003eMicroSDXC Lexar 1066x 128 GB U3 A2 V30\u003cbr\u003eMicroSDXC Lexar 1066x 256 GB U3 A2 V30\u003cbr\u003eMicroSDXC Lexar 1066x 512 GB U3 A2 V30\u003cbr\u003eKingston Canvas Go! MicroSDXC Plus 64 GB U3 A2 V30\u003cbr\u003eKingston Canvas Go! MicroSDXC Plus 128 GB U3 A2 V30\u003cbr\u003eKingston Canvas Go! MicroSDXC Plus 256 GB U3 A2 V30\u003cbr\u003eKingston Canvas Go! MicroSDXC Plus 512 GB U3 A2 V30"
                    }
                ]
            },
            {
                "title": "Aeronave - Batería",
                "specs": [
                    {
                        "key": "Capacidad",
                        "value": "6768 mAh"
                    },
                    {
                        "key": "Voltaje",
                        "value": "22.14 V"
                    },
                    {
                        "key": "Voltaje máx. de carga",
                        "value": "25.5 V"
                    },
                    {
                        "key": "Tipo de celda",
                        "value": "Li-ion 6S"
                    },
                    {
                        "key": "Sistema químico",
                        "value": "LiNiMnCoO2"
                    },
                    {
                        "key": "Energía",
                        "value": "149.9 Wh"
                    },
                    {
                        "key": "Peso",
                        "value": "640 g"
                    },
                    {
                        "key": "Recuento de ciclos",
                        "value": "400"
                    },
                    {
                        "key": "Temperatura de carga",
                        "value": "De 5 a 45 °C (de 41 a 113 °F)"
                    },
                    {
                        "key": "Tasa de descarga",
                        "value": "4C"
                    },
                    {
                        "key": "Potencia de carga máx.",
                        "value": "1.8C"
                    },
                    {
                        "key": "Carga a baja temperatura",
                        "value": "Admite carga de autocalentamiento a baja temperatura"
                    }
                ]
            },
            {
                "title": "Aeronave - Adaptador de potencia",
                "specs": [
                    {
                        "key": "Entrada",
                        "value": "100-240 V (CA), 50/60 Hz, 3 A"
                    },
                    {
                        "key": "Potencia de salida",
                        "value": "240 W"
                    },
                    {
                        "key": "Salida",
                        "value": "\u003chtml\u003eTotal: Potencia de salida máx. de 240 W; Puerto USB-C: Potencia de salida máx. de 65 W\u003cbr\u003e\u003cbr\u003e\u003csup\u003eCuando se carga con dos puertos al mismo tiempo, la potencia de salida máxima del puerto USB-C es de 45 W. \u003c/sup\u003e\u003c/html\u003e"
                    }
                ]
            },
            {
                "title": "Centro de carga",
                "specs": [
                    {
                        "key": "Entrada",
                        "value": "SDC: 16.8 V a 25.5 V, 12.1 A"
                    },
                    {
                        "key": "Potencia nominal",
                        "value": "240 W"
                    },
                    {
                        "key": "Tipo de carga",
                        "value": "3 baterías cargando en secuencia\u003cbr\u003eAdmite modo estándar (100 % SOC) y modo listo para volar (90 % SOC)"
                    },
                    {
                        "key": "Batería compatible",
                        "value": "Batería Serie DJI Matrice 4D"
                    },
                    {
                        "key": "Temperatura de carga",
                        "value": "De 5 a 40 °C (de 41 a 104 °F)"
                    }
                ]
            },
            {
                "title": "DJI RC Plus 2 Enterprise",
                "specs": [
                    {
                        "key": "Alcance máximo de transmisión (sin obstáculos, libre de interferencias)",
                        "value": "\u003chtml\u003eFCC: 25 km\u003cbr\u003eCE: 12 km\u003cbr\u003eSRRC: 12 km\u003cbr\u003eMIC: 12 km\u003cbr\u003e\u003cbr\u003e\u003csup\u003eMediciones obtenidas en un entorno sin obstáculos ni interferencias. Los datos anteriores muestran el alcance de comunicación más lejano para vuelos en un sentido y sin retorno bajo cada estándar. Durante el vuelo, presta atención al recordatorio de RPO en la aplicación DJI Pilot.\u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Frecuencia de funcionamiento de la transmisión de vídeo",
                        "value": "\u003chtml\u003e2.4000-2.4835 GHz \u003cbr\u003e5.725-5.850 GHz (No compatible en Japón)\u003cbr\u003e5.2 GHz (solo recepción)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa frecuencia de funcionamiento permitida varía entre países y regiones. Consulta la legislación y las normativas locales para obtener más información. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Antena",
                        "value": "Antena de alta ganancia integrada de multirayos 2T4R"
                    },
                    {
                        "key": "Potencia del transmisor de la transmisión de vídeo (PIRE)",
                        "value": "2.4 GHz: ＜33 dBm (FCC), ＜20 dBm (CE/SRRC/MIC)\u003cbr\u003e5.2 GHz: ＜23 dBm (CE)\u003cbr\u003e5.8 GHz: ＜33 dBm (FCC), ＜14 dBm (CE), ＜30 dBm (SRRC)"
                    },
                    {
                        "key": "Transmisión 4G",
                        "value": "\u003chtml\u003eAdaptador celular 2 DJI\u003cbr\u003e\u003cbr\u003e\u003csup\u003eSe vende por separado. Este servicio no está disponible en algunos países y regiones. Consulta los detalles a tu distribuidor local. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Protocolo de Wi-Fi",
                        "value": "Wi-Fi Direct, pantalla inalámbrica, IEEE 802.11a/b/g/n/ac/ax\u003cbr\u003eAdmite Wi-Fi MIMO 2×2, soporte de doble banda simultánea (DBS) para MAC dual, con tasas de datos de hasta 1774.5 Mbps (2×2 + 2×2 11ax doble banda simultánea)"
                    },
                    {
                        "key": "Frecuencia de funcionamiento del Wi-Fi",
                        "value": "\u003chtml\u003e2.4000-2.4835 GHz\u003cbr\u003e5.150-5.250 GHz\u003cbr\u003e5.725-5.850 GHz\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLas bandas de frecuencias de 5.8 y 5.2 GHz están prohibidas en algunos países. En algunos países, la frecuencia de 5.2 GHz está permitida únicamente para uso en interiores. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Potencia del transmisor de Wi-Fi (PIRE)",
                        "value": "2.4 GHz: ＜26 dBm (FCC), ＜20 dBm (CE/SRRC/MIC)\u003cbr\u003e5.2 GHz: ＜26 dBm (FCC), \u003c23 dBm (CE/SRRC/MIC)\u003cbr\u003e5.8 GHz: \u003c33 dBm (FCC/SRRC), \u003c14 dBm (CE)"
                    },
                    {
                        "key": "Protocolo de Bluetooth",
                        "value": "Bluetooth 5.2"
                    },
                    {
                        "key": "Frecuencia de funcionamiento de Bluetooth",
                        "value": "2.400-2.4835 GHz"
                    },
                    {
                        "key": "Potencia del transmisor de Bluetooth (PIRE)",
                        "value": "\u003c10 dBm"
                    },
                    {
                        "key": "Resolución de la pantalla",
                        "value": "1920 × 1200"
                    },
                    {
                        "key": "Tamaño de la pantalla",
                        "value": "7.02 pulgadas"
                    },
                    {
                        "key": "Tasa de fotogramas de la pantalla",
                        "value": "60 fps"
                    },
                    {
                        "key": "Brillo",
                        "value": "1400 nits"
                    },
                    {
                        "key": "Control de la pantalla táctil",
                        "value": "Multitoque de 10 puntos"
                    },
                    {
                        "key": "Batería integrada",
                        "value": "Batería de ion-litio 18650 densidad de energía alta, 2S2P (6500 mAh a 7.2 V), 46.8 Wh"
                    },
                    {
                        "key": "Batería externa",
                        "value": "Opcional, WB37 (4920 mAh a 7.6 V), 37 Wh"
                    },
                    {
                        "key": "Tipo de carga",
                        "value": "Admite carga rápida PD con una especificación máxima de cargador USB tipo C de 20 V/3.25 A."
                    },
                    {
                        "key": "Capacidad de almacenamiento",
                        "value": "RAM 8G + ROM 128G UFS + almacenamiento ampliable con tarjeta microSD"
                    },
                    {
                        "key": "Tiempo de carga",
                        "value": "\u003chtml\u003e2 horas de batería interna; 2 horas para batería interna más externa. \u003cbr\u003e\u003cbr\u003e\u003csup\u003eCuando el control remoto está desactivado y utiliza un cargador DJI estándar.\u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Tiempo de ejecución de batería interna",
                        "value": "3.8 horas"
                    },
                    {
                        "key": "Tiempo de ejecución de batería externa",
                        "value": "3.2 horas"
                    },
                    {
                        "key": "Puerto de salida",
                        "value": "HDMI 1.4"
                    },
                    {
                        "key": "Indicadores",
                        "value": "led de estado, led de nivel de batería, led de estado de conexión, luz tricolor, ajuste de brillo según la luz ambiental"
                    },
                    {
                        "key": "Altavoz",
                        "value": "Admite timbre"
                    },
                    {
                        "key": "Audio",
                        "value": "MIC de grupo"
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −20 a 50 °C (de −4 a 122 °F)"
                    },
                    {
                        "key": "Temperatura de almacenamiento",
                        "value": "En el plazo de un mes: De −30 °C a 45 °C (de −22 °F a 113 °F)\u003cbr\u003eDe uno a tres meses: De −30 °C a 35 °C (de −22 °F a 95 °F)\u003cbr\u003eDe tres meses a un año: De −30 °C a 30 °C (de −22 °F a 86 °F)"
                    },
                    {
                        "key": "Temperatura de carga",
                        "value": "De 5 a 40 °C (de 41 a 104 °F)"
                    },
                    {
                        "key": "Modelos de aeronaves compatibles",
                        "value": "Admite Matrice 4TD/4D y Matrice 4T/4E"
                    },
                    {
                        "key": "Sistemas globales de navegación por satélite",
                        "value": "GPS, Galileo, BeiDou."
                    },
                    {
                        "key": "Dimensiones",
                        "value": "\u003chtml\u003e268 × 163 × 94.5 mm (la. × an. × al.)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa anchura incluye una antena externa plegada, el grosor incluye bastones de manejo y controlador. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Peso",
                        "value": "1.15 kg (sin batería externa)"
                    },
                    {
                        "key": "Modelo",
                        "value": "TKPL 2"
                    },
                    {
                        "key": "Versión del sistema",
                        "value": "Android 11"
                    },
                    {
                        "key": "Interfaces externas",
                        "value": "HDMI 1.4, SD 3.0, Tipo-C con soporte OTG, carga PD máxima de 65 W, USB-A con soporte USB 2.0"
                    },
                    {
                        "key": "Accesorios",
                        "value": "Soporte de cintura/banda opcional"
                    }
                ]
            },
            {
                "title": "Foco AL1",
                "specs": [
                    {
                        "key": "Peso",
                        "value": "\u003chtml\u003e99 g (incluido el soporte)\u003cbr\u003e91 g (sin incluir el soporte)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eNo se requiere soporte de montaje al instalarlo en aeronaves de la Serie Matrice 4D.\u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Dimensiones",
                        "value": "95 × 164 × 30 mm (la. × an. × al, incluido el soporte)\u003cbr\u003e79 × 164 × 28 mm (la. × an. × al., sin incluir el soporte)"
                    },
                    {
                        "key": "Potencia máx.",
                        "value": "32 W"
                    },
                    {
                        "key": "Iluminación",
                        "value": "\u003chtml\u003e4.3±0.2 lux a 100 metros, 17±0.2 lux a 50 metros\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa información se midió en un entorno de laboratorio con la luz instalada de manera separada en la aeronave y en una temperatura ambiente de 25 °C.\u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Ángulo de iluminación efectivo",
                        "value": "23° (iluminación relativa del 10 %)"
                    },
                    {
                        "key": "Área de iluminación efectiva",
                        "value": "1300 metros cuadrados a 100 metros (10 % de iluminación relativa, modo normal)\u003cbr\u003e2200 metros cuadrados a 100 metros (10 % de iluminación relativa, modo campo de visión amplio)"
                    },
                    {
                        "key": "Modo de funcionamiento",
                        "value": "Admite los modos de iluminación constante y efecto estroboscópico"
                    },
                    {
                        "key": "Rango mecánico del estabilizador",
                        "value": "Inclinación: De -140° a +50°"
                    },
                    {
                        "key": "Intervalo controlable del estabilizador",
                        "value": "Inclinación: De −90° a 35°"
                    },
                    {
                        "key": "Velocidad máx. de control del estabilizador (inclinación)",
                        "value": "120°/s"
                    },
                    {
                        "key": "Precisión de alineación del estabilizador",
                        "value": "±0.1°"
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −20 a 50 °C (de −4 a 122 °F)"
                    },
                    {
                        "key": "Índice de protección de entrada",
                        "value": "IP55"
                    },
                    {
                        "key": "Montura",
                        "value": "\u003chtml\u003eTornillos de liberación rápida apretados a mano\u003cbr\u003e\u003cbr\u003e\u003csup\u003eCuando lo instales en la aeronave, aprieta los tornillos y garantiza un sellado adecuado de la interfaz. Cuando use con el DJI Dock, por favor use la llave hexagonal incluida para apretar los tornillos nuevamente. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Modelos de aeronaves compatibles",
                        "value": "Admite Matrice 4TD/4D y Matrice 4T/4E"
                    }
                ]
            },
            {
                "title": "Altavoz AS1",
                "specs": [
                    {
                        "key": "Peso",
                        "value": "\u003chtml\u003e92.5 g (incluido el soporte)\u003cbr\u003e90 g (sin incluir el soporte)\u003cbr\u003e\u003cbr\u003e\u003csup\u003eNo se requiere soporte de montaje al instalarlo en aeronaves de la Serie Matrice 4D.\u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Dimensiones",
                        "value": "73 × 70 × 52 mm (la. × an. × al, incluido el soporte)\u003cbr\u003e73 × 70 × 47 mm (la. × an. × al., sin incluir el soporte)"
                    },
                    {
                        "key": "Potencia máx.",
                        "value": "15 W"
                    },
                    {
                        "key": "Volumen máximo",
                        "value": "\u003chtml\u003eA 1 metro, puede alcanzar los 114 decibelios (114 dB a 1 m).\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa información se mide en un entorno de laboratorio a 25 °C (77° F). Las condiciones reales pueden variar un poco debido a la versión del software, la fuente de audio, el entorno específico y otros factores. El efecto final depende del uso real. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Distancia de emisión efectiva",
                        "value": "\u003chtml\u003e300 m\u003cbr\u003e\u003cbr\u003e\u003csup\u003eLa información se mide en un entorno de laboratorio a 25 °C (77° F). Las condiciones reales pueden variar un poco debido a la versión del software, la fuente de audio, el entorno específico y otros factores. El efecto final depende del uso real. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Modo Emisión",
                        "value": "\u003chtml\u003eTransmisión en tiempo real, grabación y transmisión, entrada de archivo (admite transferencia y reproducción simultáneas), texto a voz*\u003cbr\u003e\u003cbr\u003e\u003csup\u003e* Actualmente solo admite inglés y chino mandarín. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −20 a 50 °C (de −4 a 122 °F)"
                    },
                    {
                        "key": "Índice de protección de entrada",
                        "value": "IP55"
                    },
                    {
                        "key": "Montura",
                        "value": "\u003chtml\u003eTornillos de liberación rápida apretados a mano\u003cbr\u003e\u003cbr\u003e\u003csup\u003eCuando lo instales en la aeronave, aprieta los tornillos y garantiza un sellado adecuado de la interfaz. Si lo usas con DJI Dock, utiliza la llave hexagonal incluida para volver a apretar los tornillos. \u003c/sup\u003e\u003c/html\u003e"
                    },
                    {
                        "key": "Modelos de aeronaves compatibles",
                        "value": "Admite Matrice 4TD/4D y Matrice 4T/4E"
                    }
                ]
            },
            {
                "title": "Módulo de detección de obstáculos Matrice 4",
                "specs": [
                    {
                        "key": "Peso",
                        "value": "235 g"
                    },
                    {
                        "key": "Dimensiones",
                        "value": "103.3 × 64 × 85.8 mm (la. × an. × al.)"
                    },
                    {
                        "key": "Índice de protección de entrada",
                        "value": "IP55"
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −20 a 50 °C (de −4 a 122 °F)"
                    },
                    {
                        "key": "Tipo de detección",
                        "value": "Combinación de LiDAR rotativa y radar de onda milimétrica"
                    },
                    {
                        "key": "Campo de visión",
                        "value": "LiDAR: 360° vertical, 60° horizontal\u003cbr\u003eRadar de onda milimétrica: 90° vertical, 90° horizontal"
                    },
                    {
                        "key": "Rango de medición",
                        "value": "100 m de distancia máxima de detección"
                    },
                    {
                        "key": "Velocidad de detección efectiva",
                        "value": "\u003chtml\u003evelocidad de vuelo ≤15 m/s (tipo de obstáculo: Cable trenzado de aluminio con núcleo de acero de 12 mm)\u003cbr\u003e\u003cbr\u003e\u003csup\u003e1. Las capacidades para esquivar y rodear obstáculos pueden variar en función de los diferentes entornos (nubes, niebla, lluvia, nieve), y el material, la posición y la forma del objetivo.\u003cbr\u003e2. Debido a las limitaciones de rendimiento del sistema de seguridad, la aeronave no puede esquivar activamente objetos que se mueven rápidamente. Mantente cauteloso al volar en dichos entornos. \u003c/sup\u003e\u003c/html\u003e"
                    }
                ]
            },
            {
                "title": "Montura de cardán para vehículo",
                "specs": [
                    {
                        "key": "Peso",
                        "value": "Soporte de Derecha y Estabilizador: 440 g\u003cbr\u003eSoporte de Izquierda: 155 g"
                    },
                    {
                        "key": "Dimensiones",
                        "value": "Soporte de derecha y estabilizador: 112.8 × 152.2 × 157.8 mm (la. × an. × al.)\u003cbr\u003eSoporte de Izquierda: 126.3 × 172.9 × 70.3 mm (la. × an. × al.)"
                    },
                    {
                        "key": "Voltaje de carga",
                        "value": "14 V"
                    },
                    {
                        "key": "Índice de protección de entrada",
                        "value": "IP55"
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −30 a 50 °C (de −22 a 122 °F)"
                    }
                ]
            },
            {
                "title": "Sistema de Terminación de Vuelo (FTS) (vendido solo en Europa)",
                "specs": [
                    {
                        "key": "Peso",
                        "value": "10.9 g"
                    },
                    {
                        "key": "Dimensiones",
                        "value": "41.8 × 25.6 × 7.3 mm (la. × an. × al., sin incluir el puerto USB)"
                    },
                    {
                        "key": "Voltaje de carga",
                        "value": "5 V"
                    },
                    {
                        "key": "Temperatura de funcionamiento",
                        "value": "De −20 a 50 °C (de −4 a 122 °F)"
                    },
                    {
                        "key": "Método de comunicación",
                        "value": "\u003chtml\u003e4G LTE (requiere Adaptador celular 2 DJI*)\u003cbr\u003e\u003cbr\u003e\u003csup\u003e* Se vende por separado. Este servicio no está disponible en algunos países y regiones. Consulta los detalles a tu distribuidor local. \u003c/sup\u003e\u003c/html\u003e"
                    }
                ]
            },
            {
                "title": "Notas",
                "specs": [
                    {
                        "key": "",
                        "value": "Los términos HDMI, HDMI High-Definition Multimedia Interface (Interfaz multimedia de alta definición), HDMI Trade Dress (diseño e imagen comercial HDMI) y los logotipos HDMI son marcas comerciales o marcas registradas de HDMI Licensing Administrator, Inc. \u003cbr\u003e\u003cbr\u003e \u003cimg src=\"https://terra-1-g.djicdn.com/851d20f7b9f64838a34cd02351370894/HDMI_logo_R_Black40.png\" height=\"50px\" width=\"125px\"\u003e\u003c/img\u003e"
                    }
                ]
            }
        ]
    }
]